(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var styles = exports.styles = "[data-rz] .image-card {\n  display: block;\n  font-size: 0;\n  white-space: nowrap; }\n  [data-rz] .image-card:link, [data-rz] .image-card:visited, [data-rz] .image-card:hover, [data-rz] .image-card:focus, [data-rz] .image-card:active {\n    color: #231f20;\n    text-decoration: none; }\n\n[data-rz] .image-card--responsive {\n  white-space: normal; }\n\n[data-rz] .image-card--border {\n  border: 10px solid #ebebeb; }\n\n[data-rz] .image-card__img-wrapper {\n  display: inline-block;\n  font-size: 1rem;\n  vertical-align: middle;\n  width: 33%; }\n\n[data-rz] .image-card__img-wrapper--xs {\n  width: 88px; }\n\n[data-rz] .image-card--responsive .image-card__img-wrapper {\n  width: 100%; }\n  @media screen and (min-width: 744px) {\n    [data-rz] .image-card--responsive .image-card__img-wrapper {\n      width: 33%; } }\n\n[data-rz] .image-card__img-wrapper-inner {\n  position: relative;\n  height: 0;\n  padding-bottom: 60%; }\n\n[data-rz] .image-card__img-wrapper-inner--4x3 {\n  padding-bottom: 75%; }\n\n[data-rz] .image-card__img-wrapper-inner--highlighted {\n  background-color: #ffffff;\n  border: 1px solid #ebebeb; }\n\n[data-rz] .image-card__img {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: block; }\n\n[data-rz] .image-card__text {\n  display: inline-block;\n  font-size: 1rem;\n  vertical-align: middle;\n  white-space: normal;\n  width: 67%;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  padding-left: 5%;\n  padding-right: 5%; }\n\n[data-rz] .image-card__text--xs {\n  width: calc(100% - 88px); }\n\n[data-rz] .image-card__text--top {\n  vertical-align: top; }\n\n[data-rz] .image-card__text--left {\n  padding-left: 0; }\n\n[data-rz] .image-card--responsive .image-card__text {\n  width: 100%; }\n  @media screen and (min-width: 744px) {\n    [data-rz] .image-card--responsive .image-card__text {\n      width: 67%; } }\n\n[data-rz] .image-card__title {\n  color: #5c656e;\n  font-size: 17px;\n  line-height: 1.15;\n  margin: 0; }\n\n[data-rz] .image-card__sub {\n  border-top: 1px solid #f5f5f5;\n  color: #5c656e;\n  display: block;\n  font-size: 0.82353rem;\n  padding-top: 10px;\n  margin-top: 10px; }\n\n[data-rz] .image-card__desc {\n  color: #5c656e;\n  display: block;\n  margin-top: 15px; }\n\n[data-rz] .marketing-block {\n  min-height: 20px;\n  background-color: rgba(255, 255, 255, 0.5);\n  border-radius: 3px; }\n  @media screen and (min-width: 744px) {\n    [data-rz] .marketing-block {\n      padding: 15px; } }\n  @media screen and (min-width: 984px) {\n    [data-rz] .marketing-block {\n      padding: 20px; } }\n  @media screen and (min-width: 1280px) {\n    [data-rz] .marketing-block {\n      padding: 30px; } }\n  [data-rz] .marketing-block--vertical {\n    padding: 0; }\n  [data-rz] .marketing-block--highlighted {\n    background-color: #ffffff; }\n  [data-rz] .marketing-block--bordered {\n    box-shadow: 0 0 0 1px #d2d6d9 inset; }\n  [data-rz] .marketing-block__main {\n    text-align: center;\n    position: relative;\n    padding: 15px 10px 20px; }\n    @media screen and (min-width: 744px) {\n      [data-rz] .marketing-block__main {\n        padding: 0; } }\n  @media screen and (min-width: 744px) {\n    [data-rz] .marketing-block__main--vertical {\n      padding: 15px 10px 20px; } }\n  @media screen and (min-width: 1280px) {\n    [data-rz] .marketing-block__main--vertical {\n      padding-right: 15px;\n      padding-left: 15px; } }\n  [data-rz] .marketing-block__img-wrapper {\n    text-align: center; }\n  [data-rz] .marketing-block__img-wrapper--vertical {\n    width: 100%;\n    height: 144px;\n    overflow: hidden;\n    position: relative;\n    border-top-right-radius: 3px;\n    border-top-left-radius: 3px; }\n  [data-rz] .marketing-block__img {\n    max-width: 100%;\n    height: auto; }\n  [data-rz] .marketing-block__img--vertical {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    max-width: none;\n    min-width: 100%;\n    min-height: 100%; }\n  [data-rz] .marketing-block__title {\n    font-size: 1.11765rem;\n    font-weight: 500;\n    color: #2f3840;\n    margin-top: 0; }\n    @media screen and (min-width: 744px) {\n      [data-rz] .marketing-block__title {\n        font-size: 1.23529rem; } }\n    @media screen and (min-width: 984px) {\n      [data-rz] .marketing-block__title {\n        font-size: 1.52941rem; } }\n    @media screen and (min-width: 1280px) {\n      [data-rz] .marketing-block__title {\n        font-size: 1.82353rem;\n        margin-bottom: 20px; } }\n  @media screen and (min-width: 984px) {\n    [data-rz] .marketing-block__title--md {\n      font-size: 1.52941rem;\n      margin-bottom: 15px; } }\n  @media screen and (min-width: 984px) {\n    [data-rz] .marketing-block__title--sm {\n      font-size: 22px;\n      margin-bottom: 10px; } }\n  @media screen and (min-width: 744px) {\n    [data-rz] .marketing-block__title--xs {\n      font-size: 1.11765rem;\n      margin-bottom: 10px; } }\n  [data-rz] .marketing-block__desc {\n    font-size: 17px;\n    line-height: 1.26;\n    color: #5c656e;\n    margin-top: 10px;\n    margin-bottom: 20px; }\n    @media screen and (min-width: 984px) {\n      [data-rz] .marketing-block__desc {\n        font-size: 1.11765rem;\n        line-height: 1.24;\n        margin-top: 15px;\n        margin-bottom: 30px; } }\n    @media screen and (min-width: 1280px) {\n      [data-rz] .marketing-block__desc {\n        font-size: 1.23529rem;\n        line-height: 1.1;\n        margin-bottom: 35px; } }\n  @media screen and (min-width: 984px) {\n    [data-rz] .marketing-block__desc--md {\n      font-size: 1.11765rem;\n      line-height: 1.25;\n      margin-bottom: 20px; } }\n  @media screen and (min-width: 984px) {\n    [data-rz] .marketing-block__desc--sm {\n      font-size: 17px;\n      margin-top: 0;\n      margin-bottom: 20px; } }\n  @media screen and (min-width: 984px) {\n    [data-rz] .marketing-block__desc--xs {\n      font-size: 17px;\n      line-height: 1.125;\n      margin-top: 0;\n      margin-bottom: 20px; } }\n  [data-rz] .marketing-block__tag {\n    font-size: 17px;\n    font-style: italic;\n    color: #fd3753;\n    background-color: #ffffff;\n    border-radius: 3px;\n    margin-bottom: 0;\n    padding: 3px 15px;\n    position: absolute;\n    top: -20px;\n    left: 50%;\n    z-index: 2;\n    transform: translateX(-50%); }\n\n[data-rz] .author {\n  font-size: 0.82353rem;\n  white-space: nowrap; }\n  [data-rz] .author__span {\n    color: #b3b8bd; }\n  [data-rz] .author__link {\n    color: #6376ec;\n    transition: color 0.25s ease-in-out;\n    text-decoration: none; }\n    [data-rz] .author__link:hover {\n      color: #4f5ebc;\n      text-decoration: none; }\n\n[data-rz] .icon-star.icon-yellow {\n  background-image: url(\"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTc5MiIgaGVpZ2h0PSIxNzkyIiB2aWV3Qm94PSIwIDAgMTc5MiAxNzkyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGZpbGw9IiNmMmMwMGMiIGQ9Ik0xNzI4IDY0N3EwIDIyLTI2IDQ4bC0zNjMgMzU0IDg2IDUwMHExIDcgMSAyMCAwIDIxLTEwLjUgMzUuNXQtMzAuNSAxNC41cS0xOSAwLTQwLTEybC00NDktMjM2LTQ0OSAyMzZxLTIyIDEyLTQwIDEyLTIxIDAtMzEuNS0xNC41dC0xMC41LTM1LjVxMC02IDItMjBsODYtNTAwLTM2NC0zNTRxLTI1LTI3LTI1LTQ4IDAtMzcgNTYtNDZsNTAyLTczIDIyNS00NTVxMTktNDEgNDktNDF0NDkgNDFsMjI1IDQ1NSA1MDIgNzNxNTYgOSA1NiA0NnoiLz48L3N2Zz4K\"); }\n\n[data-rz] .icon-star-half-o.icon-yellow {\n  background-image: url(\"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTc5MiIgaGVpZ2h0PSIxNzkyIiB2aWV3Qm94PSIwIDAgMTc5MiAxNzkyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGZpbGw9IiNmMmMwMGMiIGQ9Ik0xMjUwIDk1N2wyNTctMjUwLTM1Ni01Mi02Ni0xMC0zMC02MC0xNTktMzIydjk2M2w1OSAzMSAzMTggMTY4LTYwLTM1NS0xMi02NnptNDUyLTI2MmwtMzYzIDM1NCA4NiA1MDBxNSAzMy02IDUxLjV0LTM0IDE4LjVxLTE3IDAtNDAtMTJsLTQ0OS0yMzYtNDQ5IDIzNnEtMjMgMTItNDAgMTItMjMgMC0zNC0xOC41dC02LTUxLjVsODYtNTAwLTM2NC0zNTRxLTMyLTMyLTIzLTU5LjV0NTQtMzQuNWw1MDItNzMgMjI1LTQ1NXEyMC00MSA0OS00MSAyOCAwIDQ5IDQxbDIyNSA0NTUgNTAyIDczcTQ1IDcgNTQgMzQuNXQtMjQgNTkuNXoiLz48L3N2Zz4K\"); }\n\n[data-rz] .icon-star-o.icon-yellow {\n  background-image: url(\"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTc5MiIgaGVpZ2h0PSIxNzkyIiB2aWV3Qm94PSIwIDAgMTc5MiAxNzkyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGZpbGw9IiNmMmMwMGMiIGQ9Ik0xMjAxIDEwMDRsMzA2LTI5Ny00MjItNjItMTg5LTM4Mi0xODkgMzgyLTQyMiA2MiAzMDYgMjk3LTczIDQyMSAzNzgtMTk5IDM3NyAxOTl6bTUyNy0zNTdxMCAyMi0yNiA0OGwtMzYzIDM1NCA4NiA1MDBxMSA3IDEgMjAgMCA1MC00MSA1MC0xOSAwLTQwLTEybC00NDktMjM2LTQ0OSAyMzZxLTIyIDEyLTQwIDEyLTIxIDAtMzEuNS0xNC41dC0xMC41LTM1LjVxMC02IDItMjBsODYtNTAwLTM2NC0zNTRxLTI1LTI3LTI1LTQ4IDAtMzcgNTYtNDZsNTAyLTczIDIyNS00NTVxMTktNDEgNDktNDF0NDkgNDFsMjI1IDQ1NSA1MDIgNzNxNTYgOSA1NiA0NnoiLz48L3N2Zz4K\"); }\n\n[data-rz] .icon-eye.icon-yellow {\n  background-image: url(\"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTc5MiIgaGVpZ2h0PSIxNzkyIiB2aWV3Qm94PSIwIDAgMTc5MiAxNzkyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGZpbGw9IiNmMmMwMGMiIGQ9Ik0xNjY0IDk2MHEtMTUyLTIzNi0zODEtMzUzIDYxIDEwNCA2MSAyMjUgMCAxODUtMTMxLjUgMzE2LjV0LTMxNi41IDEzMS41LTMxNi41LTEzMS41LTEzMS41LTMxNi41cTAtMTIxIDYxLTIyNS0yMjkgMTE3LTM4MSAzNTMgMTMzIDIwNSAzMzMuNSAzMjYuNXQ0MzQuNSAxMjEuNSA0MzQuNS0xMjEuNSAzMzMuNS0zMjYuNXptLTcyMC0zODRxMC0yMC0xNC0zNHQtMzQtMTRxLTEyNSAwLTIxNC41IDg5LjV0LTg5LjUgMjE0LjVxMCAyMCAxNCAzNHQzNCAxNCAzNC0xNCAxNC0zNHEwLTg2IDYxLTE0N3QxNDctNjFxMjAgMCAzNC0xNHQxNC0zNHptODQ4IDM4NHEwIDM0LTIwIDY5LTE0MCAyMzAtMzc2LjUgMzY4LjV0LTQ5OS41IDEzOC41LTQ5OS41LTEzOS0zNzYuNS0zNjhxLTIwLTM1LTIwLTY5dDIwLTY5cTE0MC0yMjkgMzc2LjUtMzY4dDQ5OS41LTEzOSA0OTkuNSAxMzkgMzc2LjUgMzY4cTIwIDM1IDIwIDY5eiIvPjwvc3ZnPgo=\"); }\n\n[data-rz] .icon-eye.icon-light-gray {\n  background-image: url(\"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTc5MiIgaGVpZ2h0PSIxNzkyIiB2aWV3Qm94PSIwIDAgMTc5MiAxNzkyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGZpbGw9IiNjMGM1YzkiIGQ9Ik0xNjY0IDk2MHEtMTUyLTIzNi0zODEtMzUzIDYxIDEwNCA2MSAyMjUgMCAxODUtMTMxLjUgMzE2LjV0LTMxNi41IDEzMS41LTMxNi41LTEzMS41LTEzMS41LTMxNi41cTAtMTIxIDYxLTIyNS0yMjkgMTE3LTM4MSAzNTMgMTMzIDIwNSAzMzMuNSAzMjYuNXQ0MzQuNSAxMjEuNSA0MzQuNS0xMjEuNSAzMzMuNS0zMjYuNXptLTcyMC0zODRxMC0yMC0xNC0zNHQtMzQtMTRxLTEyNSAwLTIxNC41IDg5LjV0LTg5LjUgMjE0LjVxMCAyMCAxNCAzNHQzNCAxNCAzNC0xNCAxNC0zNHEwLTg2IDYxLTE0N3QxNDctNjFxMjAgMCAzNC0xNHQxNC0zNHptODQ4IDM4NHEwIDM0LTIwIDY5LTE0MCAyMzAtMzc2LjUgMzY4LjV0LTQ5OS41IDEzOC41LTQ5OS41LTEzOS0zNzYuNS0zNjhxLTIwLTM1LTIwLTY5dDIwLTY5cTE0MC0yMjkgMzc2LjUtMzY4dDQ5OS41LTEzOSA0OTkuNSAxMzkgMzc2LjUgMzY4cTIwIDM1IDIwIDY5eiIvPjwvc3ZnPgo=\"); }\n\n[data-rz] .rating {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-align: center;\n      align-items: center; }\n\n[data-rz] .rating--right {\n  -ms-flex-flow: flex-end;\n      flex-flow: flex-end; }\n\n@media screen and (min-width: 480px) {\n  [data-rz] .rating--right-screen-xs {\n    -ms-flex-pack: end;\n        justify-content: flex-end; } }\n\n@media screen and (min-width: 744px) {\n  [data-rz] .rating--right-screen-sm {\n    -ms-flex-pack: end;\n        justify-content: flex-end; } }\n\n@media screen and (min-width: 984px) {\n  [data-rz] .rating--right-screen-md {\n    -ms-flex-pack: end;\n        justify-content: flex-end; } }\n\n@media screen and (min-width: 1024px) {\n  [data-rz] .rating--right-screen-ml {\n    -ms-flex-pack: end;\n        justify-content: flex-end; } }\n\n@media screen and (min-width: 1280px) {\n  [data-rz] .rating--right-screen-lg {\n    -ms-flex-pack: end;\n        justify-content: flex-end; } }\n\n[data-rz] .rating__icon {\n  width: 14px;\n  height: 14px; }\n  [data-rz] .rating__icon:nth-child(n+2) {\n    margin-left: -1px; }\n\n[data-rz] .rating__icon--sm {\n  width: 11px;\n  height: 11px;\n  margin-right: 2px; }\n\n@media screen and (min-width: 744px) {\n  [data-rz] .rating__icon--ml {\n    width: 20px;\n    height: 20px; } }\n\n[data-rz] .rating__click {\n  width: 20px;\n  height: 20px;\n  cursor: pointer; }\n\n[data-rz] .rating__number {\n  font-size: 0.76471rem;\n  color: #002e5d;\n  margin-right: 5px;\n  display: none; }\n  [data-rz] .rating__number--visible {\n    display: inline-block; }\n  [data-rz] .rating__number--right {\n    margin-right: 0;\n    margin-left: 2px; }\n\n[data-rz] .rating__score {\n  font-size: 0.88235rem;\n  color: #b3b8bd;\n  margin-right: 10px;\n  position: relative;\n  top: 1px;\n  display: none; }\n  [data-rz] .rating__score--visible {\n    display: inline-block; }\n\n[data-rz] .rating__info {\n  font-size: 0.88235rem;\n  font-style: italic;\n  color: #5c656e;\n  margin-left: 10px;\n  position: relative;\n  top: 1px;\n  display: none; }\n  [data-rz] .rating__info--visible {\n    display: inline-block; }\n\n[data-rz] .low-rating-notification {\n  color: #810181;\n  font-size: 15px;\n  padding: 2px; }\n\n[data-rz] .icon-tes-logo.icon-white {\n  background-image: url(\"data:image/svg+xml;base64,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\"); }\n\n[data-rz] .icon-check.icon-white {\n  background-image: url(\"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTc5MiIgaGVpZ2h0PSIxNzkyIiB2aWV3Qm94PSIwIDAgMTc5MiAxNzkyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGZpbGw9IiNmZmZmZmYiIGQ9Ik0xNjcxIDU2NnEwIDQwLTI4IDY4bC03MjQgNzI0LTEzNiAxMzZxLTI4IDI4LTY4IDI4dC02OC0yOGwtMTM2LTEzNi0zNjItMzYycS0yOC0yOC0yOC02OHQyOC02OGwxMzYtMTM2cTI4LTI4IDY4LTI4dDY4IDI4bDI5NCAyOTUgNjU2LTY1N3EyOC0yOCA2OC0yOHQ2OCAyOGwxMzYgMTM2cTI4IDI4IDI4IDY4eiIvPjwvc3ZnPgo=\"); }\n\n[data-rz] .icon-heart-o.icon-light-gray {\n  background-image: url(\"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTc5MiIgaGVpZ2h0PSIxNzkyIiB2aWV3Qm94PSIwIDAgMTc5MiAxNzkyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGZpbGw9IiNjMGM1YzkiIGQ9Ik0xNjY0IDU5NnEwLTgxLTIxLjUtMTQzdC01NS05OC41LTgxLjUtNTkuNS05NC0zMS05OC04LTExMiAyNS41LTExMC41IDY0LTg2LjUgNzItNjAgNjEuNXEtMTggMjItNDkgMjJ0LTQ5LTIycS0yNC0yOC02MC02MS41dC04Ni41LTcyLTExMC41LTY0LTExMi0yNS41LTk4IDgtOTQgMzEtODEuNSA1OS41LTU1IDk4LjUtMjEuNSAxNDNxMCAxNjggMTg3IDM1NWw1ODEgNTYwIDU4MC01NTlxMTg4LTE4OCAxODgtMzU2em0xMjggMHEwIDIyMS0yMjkgNDUwbC02MjMgNjAwcS0xOCAxOC00NCAxOHQtNDQtMThsLTYyNC02MDJxLTEwLTgtMjcuNS0yNnQtNTUuNS02NS41LTY4LTk3LjUtNTMuNS0xMjEtMjMuNS0xMzhxMC0yMjAgMTI3LTM0NHQzNTEtMTI0cTYyIDAgMTI2LjUgMjEuNXQxMjAgNTggOTUuNSA2OC41IDc2IDY4cTM2LTM2IDc2LTY4dDk1LjUtNjguNSAxMjAtNTggMTI2LjUtMjEuNXEyMjQgMCAzNTEgMTI0dDEyNyAzNDR6Ii8+PC9zdmc+Cg==\"); }\n\n[data-rz] .icon-heart.icon-red {\n  background-image: url(\"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTc5MiIgaGVpZ2h0PSIxNzkyIiB2aWV3Qm94PSIwIDAgMTc5MiAxNzkyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGZpbGw9IiNlMTY2NWMiIGQ9Ik04OTYgMTY2NHEtMjYgMC00NC0xOGwtNjI0LTYwMnEtMTAtOC0yNy41LTI2dC01NS41LTY1LjUtNjgtOTcuNS01My41LTEyMS0yMy41LTEzOHEwLTIyMCAxMjctMzQ0dDM1MS0xMjRxNjIgMCAxMjYuNSAyMS41dDEyMCA1OCA5NS41IDY4LjUgNzYgNjhxMzYtMzYgNzYtNjh0OTUuNS02OC41IDEyMC01OCAxMjYuNS0yMS41cTIyNCAwIDM1MSAxMjR0MTI3IDM0NHEwIDIyMS0yMjkgNDUwbC02MjMgNjAwcS0xOCAxOC00NCAxOHoiLz48L3N2Zz4K\"); }\n\n@keyframes placeholder-animation {\n  0% {\n    background-position: -468px 0; }\n  100% {\n    background-position: 468px 0; } }\n\n[data-rz] .resource-card:hover, [data-rz] .resource-card:focus {\n  text-decoration: none; }\n\n[data-rz] .resource-card--bundle {\n  position: relative; }\n  [data-rz] .resource-card--bundle:before, [data-rz] .resource-card--bundle:after {\n    content: \"\";\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    background-color: #ffffff;\n    border: 1px solid #d2d6d9;\n    z-index: 0; }\n  [data-rz] .resource-card--bundle:before {\n    transform: rotate(-1deg); }\n  [data-rz] .resource-card--bundle:after {\n    transform: rotate(1deg); }\n  @media screen and (min-width: 744px) {\n    [data-rz] .resource-card--bundle:before {\n      transform: rotate(-2deg); }\n    [data-rz] .resource-card--bundle:after {\n      transform: rotate(2deg); } }\n\n[data-rz] .resource-card__container {\n  width: 100%;\n  height: 92px;\n  padding: 0 0 0 120px;\n  position: relative;\n  display: block;\n  line-height: 1.42857143;\n  background-color: #ffffff;\n  border: 1px solid #d2d6d9;\n  border-radius: 3px; }\n  @media screen and (min-width: 744px) {\n    [data-rz] .resource-card__container {\n      height: auto;\n      padding: 0; } }\n\n[data-rz] .resource-card__container--bundle {\n  z-index: 1; }\n\n[data-rz] .resource-card__container--ghost {\n  border-color: transparent; }\n\n[data-rz] .resource-card__container--xxs {\n  height: 50px;\n  padding: 0 0 0 70px;\n  border: none;\n  border-radius: 3px;\n  overflow: hidden; }\n\n[data-rz] .resource-card__container--xxs-no-object {\n  padding-left: 10px; }\n\n[data-rz] .resource-card__container--xs {\n  height: 66px;\n  padding: 0 0 0 92px;\n  border: none;\n  border-radius: 3px;\n  overflow: hidden; }\n\n[data-rz] .resource-card__container--xs-right {\n  height: 66px;\n  padding: 0 92px 0 3px;\n  border: none;\n  border-radius: 3px;\n  overflow: hidden; }\n\n[data-rz] .resource-card__container--sm {\n  height: 92px;\n  padding: 0 0 0 120px; }\n\n@media screen and (min-width: 744px) {\n  [data-rz] .resource-card__container--md {\n    height: 122px;\n    padding: 0 0 30px 120px; } }\n\n@media screen and (min-width: 744px) {\n  [data-rz] .resource-card__container--xl {\n    height: 282px;\n    padding: 0 0 0 50%; } }\n\n@media (max-width: 743px) {\n  [data-rz] .resource-card__container--video {\n    padding-right: 5px;\n    padding-left: 133px; } }\n\n[data-rz] .resource-card__container--highlighted {\n  background-color: #f5f5f5; }\n\n[data-rz] .resource-card__container--bordered {\n  border: 1px solid #ebebeb; }\n\n[data-rz] .resource-card__container--bordered-dark {\n  border: 1px solid #d2d6d9; }\n\n[data-rz] .resource-card__container--preview {\n  padding-right: 84px; }\n\n[data-rz] .resource-card__recommended {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  position: absolute;\n  top: -5px;\n  left: 10px;\n  max-width: 90%;\n  padding: 3px 7px;\n  height: 22px;\n  background-color: #ffffff;\n  border: 1px solid #ffffff;\n  border-radius: 2px 2px 2px 0;\n  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.1);\n  pointer-events: none;\n  z-index: 2; }\n  [data-rz] .resource-card__recommended:before {\n    content: \"\";\n    position: absolute;\n    top: -1px;\n    left: -5px;\n    width: 0;\n    height: 0;\n    border-style: solid;\n    border-width: 0 0 4px 4px;\n    border-color: transparent transparent #b3b8bd; }\n    @media screen and (min-width: 744px) {\n      [data-rz] .resource-card__recommended:before {\n        top: auto;\n        bottom: -5px;\n        left: -1px;\n        transform: rotate(270deg); } }\n  @media screen and (min-width: 744px) {\n    [data-rz] .resource-card__recommended {\n      left: -5px;\n      top: 13px; } }\n\n@media screen and (min-width: 744px) {\n  [data-rz] .resource-card__recommended--right:before {\n    left: auto;\n    right: -1px;\n    transform: rotate(180deg); } }\n\n@media screen and (min-width: 744px) {\n  [data-rz] .resource-card__recommended--right {\n    left: auto;\n    right: -5px;\n    border-radius: 2px 2px 0 2px; } }\n\n[data-rz] .resource-card__recommended-txt {\n  font-size: 0.70588rem;\n  font-weight: 500;\n  letter-spacing: .3px;\n  display: inline-block;\n  vertical-align: middle;\n  line-height: 16px; }\n\n[data-rz] .resource-card__recommended-icon {\n  width: 13px;\n  height: 11px;\n  display: inline-block;\n  vertical-align: middle; }\n\n[data-rz] .resource-card__recommended-callout {\n  font-size: 0.76471rem;\n  font-style: italic;\n  text-transform: uppercase;\n  color: #5c656e;\n  height: 14px;\n  margin-left: 8px;\n  padding-left: 9px;\n  position: relative;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: none; }\n  [data-rz] .resource-card__recommended-callout:before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 1px;\n    height: 16px;\n    background-color: #d2d6d9; }\n  @media screen and (min-width: 744px) {\n    [data-rz] .resource-card__recommended-callout {\n      display: inline-block; } }\n\n@media screen and (min-width: 744px) {\n  [data-rz] .resource-card__quick-view-container {\n    position: relative; }\n    .resource-card__container--md [data-rz] .resource-card__quick-view-container,\n    .resource-card__container--sm [data-rz] .resource-card__quick-view-container,\n    .resource-card__container--xs [data-rz] .resource-card__quick-view-container,\n    .resource-card__container--xxs [data-rz] .resource-card__quick-view-container {\n      position: static; } }\n\n[data-rz] .resource-card__quick-view--always-visible {\n  display: none; }\n  @media screen and (min-width: 744px) {\n    [data-rz] .resource-card__quick-view--always-visible {\n      display: block;\n      font-size: 1.11765rem;\n      text-align: center;\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      width: 100%;\n      padding: 10px;\n      color: #f5f5f5;\n      background-color: rgba(0, 0, 0, 0.6);\n      transition: all 0.25s ease-in-out;\n      cursor: pointer;\n      z-index: 1;\n      opacity: 1; } }\n  [data-rz] .resource-card__quick-view--always-visible:hover {\n    color: #ffffff;\n    background-color: rgba(0, 0, 0, 0.7); }\n  .resource-card__container--md [data-rz] .resource-card__quick-view--always-visible,\n  .resource-card__container--sm [data-rz] .resource-card__quick-view--always-visible,\n  .resource-card__container--xs [data-rz] .resource-card__quick-view--always-visible,\n  .resource-card__container--xxs [data-rz] .resource-card__quick-view--always-visible {\n    display: none; }\n\n[data-rz] .resource-card__quick-view {\n  display: none; }\n  @media screen and (min-width: 744px) {\n    [data-rz] .resource-card__quick-view {\n      display: block;\n      font-size: 1.11765rem;\n      text-align: center;\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      width: 100%;\n      padding: 10px;\n      color: #f5f5f5;\n      background-color: rgba(0, 0, 0, 0.6);\n      transition: all 0.25s ease-in-out;\n      cursor: pointer;\n      z-index: 1;\n      opacity: 0; }\n      .resource-card:hover [data-rz] .resource-card__quick-view {\n        opacity: 1; } }\n  [data-rz] .resource-card__quick-view:hover {\n    color: #ffffff;\n    background-color: rgba(0, 0, 0, 0.7); }\n  .resource-card__container--md [data-rz] .resource-card__quick-view,\n  .resource-card__container--sm [data-rz] .resource-card__quick-view,\n  .resource-card__container--xs [data-rz] .resource-card__quick-view,\n  .resource-card__container--xxs [data-rz] .resource-card__quick-view {\n    display: none; }\n\n[data-rz] .resource-card__badge {\n  position: absolute;\n  top: -8px;\n  left: -8px;\n  z-index: 2;\n  overflow: hidden;\n  width: 100px;\n  height: 100px;\n  cursor: pointer; }\n\n[data-rz] .resource-card__badge-copy {\n  font-size: 0.88235rem;\n  font-style: italic;\n  text-align: center;\n  line-height: 25px;\n  color: #ffffff;\n  background-color: #fe864c;\n  transform: rotate(-45deg);\n  width: 120px;\n  height: 26px;\n  display: block;\n  position: absolute;\n  top: 18px;\n  left: -28px; }\n  [data-rz] .resource-card__badge-copy:before {\n    content: \"\";\n    position: absolute;\n    left: 2px;\n    bottom: -10px;\n    border-left: 5px solid #eb612a;\n    border-right: 5px solid transparent;\n    border-bottom: 5px solid transparent;\n    border-top: 5px solid #eb612a; }\n  [data-rz] .resource-card__badge-copy:after {\n    content: \"\";\n    position: absolute;\n    right: 3px;\n    bottom: -10px;\n    border-left: 5px solid transparent;\n    border-right: 5px solid #eb612a;\n    border-bottom: 5px solid transparent;\n    border-top: 5px solid #eb612a; }\n\n[data-rz] .resource-card__media-body {\n  display: block;\n  width: 100%;\n  height: 63px;\n  overflow: hidden;\n  padding: 3px 10px;\n  vertical-align: top;\n  zoom: 1; }\n  @media (max-width: 743px) {\n    [data-rz] .resource-card__media-body {\n      display: block;\n      width: 100%; } }\n  @media screen and (min-width: 744px) {\n    [data-rz] .resource-card__media-body {\n      height: 105px;\n      padding: 0 15px; } }\n\n[data-rz] .resource-card__media-body--xxs {\n  height: 50px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-pack: center;\n      justify-content: center;\n  border: none; }\n  @media screen and (min-width: 744px) {\n    [data-rz] .resource-card__media-body--xxs {\n      padding: 6px; } }\n\n[data-rz] .resource-card__media-body--xs {\n  height: 66px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-pack: center;\n      justify-content: center;\n  border: none; }\n  @media screen and (min-width: 744px) {\n    [data-rz] .resource-card__media-body--xs {\n      padding: 6px; } }\n\n@media screen and (min-width: 744px) {\n  [data-rz] .resource-card__media-body--sm {\n    padding: 3px 10px; } }\n\n@media screen and (min-width: 744px) {\n  [data-rz] .resource-card__media-body--md {\n    padding: 5px 10px; } }\n\n@media screen and (min-width: 744px) {\n  [data-rz] .resource-card__media-body--xl {\n    padding: 30px;\n    height: auto; } }\n\n[data-rz] .resource-card__media-body--ghost {\n  border: none;\n  position: relative;\n  width: 90%;\n  overflow: visible; }\n  [data-rz] .resource-card__media-body--ghost:before, [data-rz] .resource-card__media-body--ghost:after {\n    content: \"\";\n    display: block;\n    height: 6px;\n    background-color: #ebebeb;\n    position: absolute;\n    left: 8px;\n    animation-duration: 2s;\n    animation-fill-mode: forwards;\n    animation-iteration-count: infinite;\n    animation-name: placeholder-animation;\n    animation-timing-function: linear;\n    background-color: #ebebeb;\n    background-image: linear-gradient(to right, #ebebeb 0%, #fcfcfc 20%, #ebebeb 40%, #ebebeb 100%);\n    background-image: -moz-linear-gradient(to right, #ebebeb 0%, #fcfcfc 20%, #ebebeb 40%, #ebebeb 100%);\n    background-repeat: no-repeat;\n    background-size: 800px 100%; }\n    @media screen and (min-width: 1280px) {\n      [data-rz] .resource-card__media-body--ghost:before, [data-rz] .resource-card__media-body--ghost:after {\n        height: 7px; } }\n  [data-rz] .resource-card__media-body--ghost:before {\n    width: 90%;\n    top: 10px; }\n  [data-rz] .resource-card__media-body--ghost:after {\n    width: 40%;\n    top: 30px; }\n  [data-rz] .resource-card__media-body--ghost.resource-card__media-body--xxs:before {\n    top: 15px; }\n  [data-rz] .resource-card__media-body--ghost.resource-card__media-body--xxs:before, [data-rz] .resource-card__media-body--ghost.resource-card__media-body--xxs:after {\n    height: 5px; }\n  [data-rz] .resource-card__media-body--ghost.resource-card__media-body--xs:before {\n    top: 20px;\n    height: 6px; }\n  [data-rz] .resource-card__media-body--ghost.resource-card__media-body--xs:after {\n    top: 40px;\n    height: 6px; }\n\n[data-rz] .resource-card__media-body--video {\n  border-left: 0;\n  height: auto;\n  padding: 0; }\n\n[data-rz] .resource-card__media-body--no-footer {\n  height: 100%; }\n\n@media screen and (min-width: 744px) {\n  [data-rz] .resource-card__clip {\n    height: 74px;\n    overflow: hidden; } }\n\n[data-rz] .resource-card__clip--sm,\n[data-rz] .resource-card__clip--xl {\n  height: auto; }\n\n[data-rz] .resource-card__clip--md {\n  height: 56px; }\n\n[data-rz] .resource-card__author--xs {\n  position: absolute;\n  bottom: 6px;\n  left: 6px;\n  height: 16px;\n  overflow: hidden; }\n\n@media screen and (min-width: 744px) {\n  [data-rz] .resource-card__author--review {\n    bottom: 3px; } }\n\n@media (max-width: 743px) {\n  [data-rz] .resource-card__author--video {\n    position: relative;\n    bottom: auto;\n    left: auto; } }\n\n@media screen and (min-width: 984px) {\n  [data-rz] .resource-card__author--video {\n    margin-top: 5px; } }\n\n@media screen and (min-width: 1280px) {\n  [data-rz] .resource-card__author--video {\n    margin-top: 0; } }\n\n[data-rz] .resource-card__media-footer--sale .resource-card__price,\n[data-rz] .resource-card__media-footer__list--sale .resource-card__price {\n  color: #fd7037; }\n\n[data-rz] .resource-card__media-footer--sale .resource-card__currency,\n[data-rz] .resource-card__media-footer__list--sale .resource-card__currency {\n  color: #fd7037;\n  font-size: 0.82353rem;\n  font-style: italic;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline; }\n  @media screen and (min-width: 984px) {\n    [data-rz] .resource-card__media-footer--sale .resource-card__currency,\n    [data-rz] .resource-card__media-footer__list--sale .resource-card__currency {\n      top: -2px; } }\n\n[data-rz] .resource-card__media-footer {\n  border-top: 1px solid #ebebeb;\n  margin: 0;\n  padding: 0;\n  height: 27px;\n  overflow: hidden;\n  position: relative;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: end;\n      justify-content: flex-end; }\n  @media screen and (min-width: 744px) {\n    [data-rz] .resource-card__media-footer {\n      height: 37px; } }\n  [data-rz] .resource-card__media-footer:before, [data-rz] .resource-card__media-footer:after {\n    display: table;\n    content: \" \";\n    clear: both; }\n\n[data-rz] .resource-card__media-footer--ghost {\n  background-color: transparent;\n  border: none; }\n  @media screen and (min-width: 744px) {\n    [data-rz] .resource-card__media-footer--ghost:before, [data-rz] .resource-card__media-footer--ghost:after {\n      content: \"\";\n      display: block;\n      height: 6px;\n      background-color: #ebebeb;\n      position: absolute;\n      bottom: 11px;\n      animation-duration: 2s;\n      animation-fill-mode: forwards;\n      animation-iteration-count: infinite;\n      animation-name: placeholder-animation;\n      animation-timing-function: linear;\n      background-color: #ebebeb;\n      background-image: linear-gradient(to right, #ebebeb 0%, #fcfcfc 20%, #ebebeb 40%, #ebebeb 100%);\n      background-image: -moz-linear-gradient(to right, #ebebeb 0%, #fcfcfc 20%, #ebebeb 40%, #ebebeb 100%);\n      background-repeat: no-repeat;\n      background-size: 800px 100%; }\n    [data-rz] .resource-card__media-footer--ghost:before {\n      width: 75px;\n      left: 11px; }\n    [data-rz] .resource-card__media-footer--ghost:after {\n      width: 45px;\n      right: 11px; } }\n  @media screen and (min-width: 1280px) {\n    [data-rz] .resource-card__media-footer--ghost:before, [data-rz] .resource-card__media-footer--ghost:after {\n      height: 7px; } }\n\n[data-rz] .resource-card__media-footer--sm {\n  height: 27px;\n  margin: 0;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: calc(100% - 120px);\n  border-left: none; }\n\n[data-rz] .resource-card__media-footer--md {\n  margin: 0; }\n  @media screen and (min-width: 744px) {\n    [data-rz] .resource-card__media-footer--md {\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      width: 100%;\n      height: 30px; }\n      [data-rz] .resource-card__media-footer--md.resource-card__media-footer--ghost:before {\n        width: 75px;\n        left: 9px; }\n      [data-rz] .resource-card__media-footer--md.resource-card__media-footer--ghost:after {\n        width: 120px;\n        right: 3px; } }\n\n@media screen and (min-width: 744px) {\n  [data-rz] .resource-card__media-footer--xl {\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    width: 50%;\n    height: 45px;\n    margin: 0; } }\n\n[data-rz] .resource-card__media-footer__list {\n  display: inline-block;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  height: 26px;\n  list-style-type: none;\n  min-width: 36px;\n  margin-right: auto;\n  padding-left: 10px;\n  padding-right: 10px;\n  position: absolute;\n  top: 50%;\n  left: 0;\n  transform: translateY(-50%);\n  -ms-transform: translateY(-50%); }\n  @media screen and (min-width: 744px) {\n    [data-rz] .resource-card__media-footer__list {\n      height: 36px;\n      padding-left: 15px;\n      padding-right: 5px; } }\n\n[data-rz] .resource-card__media-footer__list--aside {\n  float: right;\n  margin-right: 0;\n  padding: 0 10px;\n  position: relative;\n  top: auto;\n  left: auto;\n  transform: none;\n  -ms-transform: none; }\n  @media screen and (min-width: 744px) {\n    [data-rz] .resource-card__media-footer__list--aside {\n      min-width: 45px;\n      padding: 5px 15px 5px 5px; } }\n\n[data-rz] .resource-card__media-footer__list--sm {\n  padding-left: 10px;\n  padding-right: 10px;\n  min-width: 36px;\n  height: 27px; }\n\n[data-rz] .resource-card__media-footer__list--md {\n  height: 26px;\n  padding-left: 10px;\n  padding-right: 10px; }\n  @media screen and (min-width: 744px) {\n    [data-rz] .resource-card__media-footer__list--md {\n      height: 30px; } }\n\n@media screen and (min-width: 744px) {\n  [data-rz] .resource-card__media-footer__list--xl {\n    padding-left: 30px;\n    min-width: 36px;\n    height: 45px; }\n    [data-rz] .resource-card__media-footer__list--xl.resource-card__media-footer__list--aside {\n      padding-left: 0;\n      padding-right: 20px; } }\n\n[data-rz] .resource-card__media-footer-text {\n  font-size: 0.76471rem;\n  text-transform: uppercase;\n  line-height: 1.8;\n  color: #5c656e; }\n\n[data-rz] .resource-card__media-footer__icon {\n  width: .875rem;\n  height: .875rem;\n  cursor: pointer;\n  transition: opacity 0.25s ease-in-out; }\n  [data-rz] .resource-card__media-footer__icon:hover {\n    opacity: .8; }\n\n[data-rz] .resource-card__price {\n  font-size: 0.88235rem;\n  text-transform: uppercase;\n  color: #3e474f;\n  display: inline-block; }\n  @media screen and (min-width: 744px) {\n    [data-rz] .resource-card__price {\n      font-size: 1.11765rem; } }\n\n[data-rz] .resource-card__price--sm {\n  font-size: 0.88235rem; }\n\n[data-rz] .resource-card__price--md {\n  font-size: 0.88235rem; }\n\n[data-rz] .resource-card__discount {\n  font-size: 0.76471rem;\n  line-height: 1;\n  text-align: right;\n  color: #b3b8bd;\n  margin-right: 8px;\n  display: none; }\n  @media screen and (min-width: 744px) {\n    [data-rz] .resource-card__discount {\n      display: block; } }\n  .l-contextual [data-rz] .resource-card__discount,\n  .resource-card__media-footer__list--sm [data-rz] .resource-card__discount {\n    display: none; }\n\n[data-rz] .resource-card__old-price {\n  font-size: 0.76471rem;\n  line-height: 1;\n  text-decoration: line-through;\n  text-align: right;\n  color: #b3b8bd;\n  margin-right: 8px;\n  display: none; }\n  @media screen and (min-width: 744px) {\n    [data-rz] .resource-card__old-price {\n      display: block; } }\n  .l-contextual [data-rz] .resource-card__old-price {\n    display: none; }\n\n[data-rz] .resource-card__currency {\n  font-size: 0.88235rem;\n  color: #5c656e; }\n  @media screen and (min-width: 744px) {\n    [data-rz] .resource-card__currency {\n      font-size: 1.11765rem; } }\n\n[data-rz] .resource-card__currency--sm {\n  font-size: 0.88235rem; }\n\n[data-rz] .resource-card__currency--md {\n  font-size: 0.88235rem; }\n\n[data-rz] .resource-card__media-footer__price {\n  font-size: 0.88235rem;\n  font-weight: 500;\n  text-transform: uppercase;\n  color: #222222;\n  display: inline-block; }\n\n[data-rz] .resource-card__media-footer__price--old {\n  font-size: 0.82353rem;\n  font-style: italic;\n  line-height: 1;\n  text-decoration: line-through;\n  text-align: right;\n  color: #b3b8bd;\n  margin-right: 5px;\n  display: none; }\n  @media screen and (min-width: 744px) {\n    [data-rz] .resource-card__media-footer__price--old {\n      display: block; } }\n\n[data-rz] .resource-card__media-footer__currency {\n  font-size: 0.88235rem;\n  font-weight: 500;\n  color: #222222; }\n\n[data-rz] .resource-card__media-footer--sale .resource-card__media-footer__price,\n[data-rz] .resource-card__media-footer--sale .resource-card__media-footer__currency,\n[data-rz] .resource-card__media-footer__list--sale .resource-card__media-footer__price,\n[data-rz] .resource-card__media-footer__list--sale .resource-card__media-footer__currency {\n  color: #fd7037; }\n\n[data-rz] .resource-card__media-footer__text {\n  font-size: 0.76471rem;\n  text-transform: uppercase;\n  line-height: 1.8;\n  color: #5c656e;\n  padding-right: 2px;\n  padding-left: 2px; }\n\n[data-rz] .resource-card__media-object-container {\n  display: block;\n  overflow: hidden;\n  position: relative; }\n\n@media screen and (min-width: 0) and (max-width: 744px) {\n  [data-rz] .resource-card__media-object-container {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 120px;\n    height: 90px; } }\n  @media screen and (min-width: 744px) {\n    [data-rz] .resource-card__media-object-container {\n      margin-bottom: 10px;\n      padding-bottom: 75%; } }\n  [data-rz] .resource-card__media-object-container:before {\n    content: \"\";\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    background-color: rgba(0, 0, 0, 0.025);\n    z-index: 1;\n    transition: background-color .25s ease-in-out; }\n  [data-rz] .resource-card__media-object-container:hover:before {\n    background-color: transparent; }\n\n[data-rz] .resource-card__media-object-container--xxs {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 66px;\n  height: 50px;\n  margin-bottom: 0;\n  padding-bottom: 0; }\n\n[data-rz] .resource-card__media-object-container--xs {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 88px;\n  height: 66px;\n  margin-bottom: 0;\n  padding-bottom: 0; }\n\n[data-rz] .resource-card__media-object-container--xs-right {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: auto;\n  width: 88px;\n  height: 66px;\n  margin-bottom: 0;\n  padding-bottom: 0; }\n\n[data-rz] .resource-card__media-object-container--xs-right-2x1 {\n  position: absolute;\n  top: 50%;\n  right: 2px;\n  left: auto;\n  width: 84px;\n  height: 42px;\n  margin-bottom: 0;\n  padding-bottom: 0;\n  transform: translateY(-50%); }\n\n[data-rz] .resource-card__media-object-container--sm {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 120px;\n  height: 90px;\n  margin-bottom: 0;\n  padding-bottom: 0; }\n\n[data-rz] .resource-card__media-object-container--md {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 120px;\n  height: 90px;\n  margin-bottom: 0;\n  padding-bottom: 0; }\n\n@media screen and (min-width: 744px) {\n  [data-rz] .resource-card__media-object-container--xl {\n    position: absolute;\n    padding-bottom: 0;\n    top: 0;\n    left: 0;\n    width: 50%;\n    height: 100%; } }\n\n[data-rz] .resource-card__media-object-container--ghost {\n  background-color: #ebebeb; }\n  [data-rz] .resource-card__media-object-container--ghost:before {\n    display: none; }\n  [data-rz] .resource-card__media-object-container--ghost.resource-card__media-object-container--xxs {\n    top: 3px;\n    left: 3px;\n    width: 64px;\n    height: 44px; }\n  [data-rz] .resource-card__media-object-container--ghost.resource-card__media-object-container--xs {\n    top: 3px;\n    left: 3px;\n    width: 86px;\n    height: 60px; }\n\n[data-rz] .resource-card__media-object {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: auto;\n  min-height: 100%; }\n\n[data-rz] .resource-card__media-heading {\n  font-size: 0.88235rem;\n  font-weight: 500;\n  line-height: 1.13;\n  margin-top: 0;\n  margin-bottom: 0;\n  overflow: hidden;\n  height: 32px; }\n  @media screen and (min-width: 744px) {\n    [data-rz] .resource-card__media-heading {\n      font-size: 17px;\n      height: 40px; } }\n\n[data-rz] .resource-card__media-heading--xxs {\n  font-size: 0.88235rem;\n  height: auto;\n  max-height: 34px; }\n  @media screen and (min-width: 744px) {\n    [data-rz] .resource-card__media-heading--xxs {\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-direction: row;\n          flex-direction: row;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n      -ms-flex-align: baseline;\n          align-items: baseline;\n      margin-bottom: 0; } }\n\n[data-rz] .resource-card__media-heading--xs {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  height: auto; }\n\n@media screen and (min-width: 744px) {\n  [data-rz] .resource-card__media-heading--sm {\n    font-size: 0.88235rem;\n    height: 32px;\n    margin-top: 2px; } }\n\n[data-rz] .resource-card__media-heading--md {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  height: auto; }\n  @media screen and (min-width: 744px) {\n    [data-rz] .resource-card__media-heading--md {\n      margin-top: 2px;\n      margin-bottom: 2px; } }\n\n@media screen and (min-width: 744px) {\n  [data-rz] .resource-card__media-heading--xl {\n    font-size: 1.23529rem;\n    height: auto;\n    max-height: 50px;\n    margin-bottom: 12px; } }\n\n[data-rz] .resource-card__media-heading--video {\n  height: auto;\n  max-height: 19px;\n  font-weight: 400;\n  margin-top: 3px;\n  margin-bottom: 2px; }\n  @media screen and (min-width: 744px) {\n    [data-rz] .resource-card__media-heading--video {\n      font-size: 1.11765rem;\n      max-height: 65px;\n      margin-top: 5px;\n      margin-bottom: 5px; } }\n\n[data-rz] .resource-card__media-heading-link {\n  transition: color 0.25s ease-in-out; }\n  [data-rz] .resource-card__media-heading-link, [data-rz] .resource-card__media-heading-link:focus {\n    color: #2f3840;\n    text-decoration: none; }\n  [data-rz] .resource-card__media-heading-link:hover {\n    color: #4f5ebc;\n    text-decoration: none; }\n\n[data-rz] .resource-card__media-heading-link--xxs {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: block; }\n\n[data-rz] .resource-card__media-heading-price {\n  font-size: 0.88235rem;\n  display: block;\n  -ms-flex-align: baseline;\n      align-items: baseline;\n  white-space: nowrap; }\n\n@media screen and (min-width: 0) and (max-width: 744px) {\n  [data-rz] .resource-card__media-heading-price {\n    font-weight: 400; } }\n  @media screen and (min-width: 744px) {\n    [data-rz] .resource-card__media-heading-price {\n      margin-left: 10px; } }\n\n[data-rz] .resource-card__media-heading-price-currency {\n  color: #5c656e; }\n\n[data-rz] .resource-card__media-heading-price-amount {\n  color: #2f3840; }\n\n[data-rz] .resource-card__media-heading-price-old {\n  font-size: 0.82353rem;\n  color: #b3b8bd;\n  margin-right: 2px;\n  text-decoration: line-through; }\n\n[data-rz] .resource-card__media-description {\n  font-size: 0.88235rem;\n  line-height: 1.1;\n  color: #5c656e;\n  height: 35px;\n  overflow: hidden;\n  margin-bottom: 0; }\n  [data-rz] .resource-card__media-description:link {\n    display: block;\n    color: #5c656e;\n    transition: color 0.25s ease-in-out; }\n    [data-rz] .resource-card__media-description:link:hover {\n      color: #44a4f6;\n      text-decoration: none; }\n\n@media screen and (min-width: 0) and (max-width: 744px) {\n  [data-rz] .resource-card__media-description {\n    display: none; } }\n\n[data-rz] .resource-card__media-description--xs {\n  display: block;\n  height: 16px;\n  margin-bottom: 7px;\n  overflow: hidden; }\n  @media screen and (min-width: 984px) {\n    [data-rz] .resource-card__media-description--xs {\n      font-size: 17px;\n      height: 18px; } }\n\n[data-rz] .resource-card__media-description--sm {\n  display: none; }\n\n@media screen and (min-width: 744px) {\n  [data-rz] .resource-card__media-description--xl {\n    line-height: 1.27;\n    height: auto;\n    max-height: 75px;\n    margin-bottom: 12px; } }\n\n[data-rz] .resource-card__media-description--video {\n  overflow: hidden;\n  max-height: 24px;\n  margin-bottom: 8px; }\n  @media screen and (min-width: 744px) {\n    [data-rz] .resource-card__media-description--video {\n      max-height: 120px;\n      margin-bottom: 10px; } }\n  @media screen and (min-width: 1280px) {\n    [data-rz] .resource-card__media-description--video {\n      max-height: 180px; } }\n\n@media (max-width: 743px) {\n  [data-rz] .resource-card--video .embed-container {\n    position: absolute;\n    top: 3px;\n    left: 3px;\n    width: 120px;\n    height: 90px;\n    padding: 0; }\n  [data-rz] .resource-card--video .embed-responsive-16by9 {\n    padding-bottom: 90px; } }\n\n@media screen and (min-width: 744px) {\n  [data-rz] .resource-card--video aside {\n    padding: 5px 25px 10px; }\n  [data-rz] .resource-card--video .author {\n    margin-top: 0;\n    padding-top: 0; }\n  [data-rz] .resource-card--video .author-logo {\n    margin-top: 0; } }\n\n@media screen and (min-width: 984px) {\n  [data-rz] .resource-card--video aside {\n    padding: 0 20px 0 0; } }\n\n[data-rz] .resource-card__text,\n[data-rz] .resource-card__datetime {\n  font-size: 0.88235rem;\n  color: #5c656e;\n  font-style: italic;\n  margin-bottom: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  text-decoration: none; }\n\n[data-rz] .resource-card__preview {\n  font-size: 0.76471rem;\n  text-align: center;\n  text-decoration: none;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  color: #5c656e;\n  background-color: #ffffff;\n  border-left: 1px solid #ebebeb;\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 82px;\n  height: 100%;\n  transition: background-color 0.25s ease-in-out;\n  cursor: pointer; }\n  [data-rz] .resource-card__preview:hover, [data-rz] .resource-card__preview:focus {\n    text-decoration: none;\n    color: #5c656e;\n    background-color: #f5f5f5; }\n\n.image-card__image-wrapper--shift-up {\n  transform: translateY(-50%);\n  float: right; }\n\n.image-card__text--full-width {\n  width: 100%;\n  display: block; }\n\n.image-card__img-wrapper-inner--no-border {\n  border: 0; }\n\n.rz-list__right {\n  padding-left: 10px;\n  text-align: right;\n  display: table-cell;\n  vertical-align: top;\n  width: 98px; }\n\n.rz-list__left {\n  text-align: left;\n  display: table-cell;\n  vertical-align: middle; }\n\n.rz-highlight-orange {\n  color: #eb612a;\n  font-weight: 500; }\n\n.rz-exclusive-footer {\n  position: relative;\n  display: table;\n  width: 100%;\n  padding-top: 10px;\n  padding-bottom: 10px; }\n  .rz-exclusive-footer:after {\n    content: '';\n    display: block;\n    position: absolute;\n    top: 0;\n    left: -15px;\n    right: -15px;\n    height: 1px;\n    background-color: #CFDAE5; }\n\n.rz-exclusive-container {\n  border: 1px solid #CFDAE5;\n  background-color: #ffffff; }\n\n.rz-exclusive-container__content {\n  margin-left: 15px;\n  margin-right: 15px;\n  padding-bottom: 2px; }\n\n.rz-container__content {\n  margin-left: 20px;\n  margin-right: 20px;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  padding-bottom: 10px; }\n\n.rz-exclusive-banner {\n  margin-bottom: 5px; }\n\n.rz-exclusive-banner__empty {\n  height: 1em; }\n\n.rz-image-card__text {\n  padding-top: 0;\n  padding-bottom: 0;\n  line-height: 1.35;\n  width: calc(100% - 100px); }\n\n.rz-image-card__wrapper-width {\n  width: 100px; }\n\n.rz-item {\n  border-bottom: 1px solid #CFDAE5;\n  padding-bottom: 10px;\n  margin-bottom: 10px; }\n  .rz-item:last-child {\n    margin-bottom: -10px;\n    border: 0;\n    padding-bottom: 0; }\n\n.rz-item--exclusive {\n  border: 0;\n  padding-bottom: 0; }\n\n.rz-item__title {\n  line-height: 17px; }\n\n.rz-item--rating-container {\n  font-size: 0.82353rem; }\n  .rz-item--rating-container:before, .rz-item--rating-container:after {\n    content: \" \";\n    display: table; }\n  .rz-item--rating-container:after {\n    clear: both; }\n\n.rz-item--rating__content {\n  display: inline-block; }\n\n.rz-item--price__content {\n  display: inline-block;\n  float: right; }\n\n.rz-exclusive__heading {\n  font-size: 16px; }\n\n.rz-exclusive__content {\n  white-space: normal;\n  line-height: 1.35; }\n\n.rz-exclusive__content--padding {\n  padding: 0 15px 10px 15px; }\n\n.rz-exclusive__footer {\n  padding: 10px 15px;\n  font-size: 0.82353rem; }\n  .rz-exclusive__footer:before, .rz-exclusive__footer:after {\n    content: \" \";\n    display: table; }\n  .rz-exclusive__footer:after {\n    clear: both; }\n\n.rz-institute-container {\n  background-color: #ffffff;\n  border-radius: 0.3em; }\n\n.rz-institute-img {\n  border-radius: 0.3em 0.3em 0 0; }\n\n.l-pos-center {\n  -ms-transform: translate(-50%, -50%); }\n\n.rz-resource, .rz-news {\n  padding-bottom: 8px;\n  margin-bottom: 8px; }\n  .rz-resource > article, .rz-news > article {\n    margin-bottom: 0; }\n  .rz-resource .image-card__img-wrapper, .rz-news .image-card__img-wrapper {\n    width: 100px; }\n  .rz-resource .image-card__text, .rz-news .image-card__text {\n    padding-top: 0;\n    padding-bottom: 0;\n    padding-right: 0;\n    line-height: 1.35;\n    width: calc(100% - 100px); }\n\n.rz-resource .image-card__text {\n  padding-left: 8px;\n  padding-right: 0px; }\n\n.rz-resource .rz-item__title {\n  min-height: 36px; }\n\n.rz-news .image-card__text--left {\n  padding-right: 8px; }\n\n.icon-bookmark-v2.icon-light-gray {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18'%3E%3Ctitle%3EFill 4%3C/title%3E%3Cpath d='M11.704 0H.688C.307 0 0 .308 0 .687v16.626c0 .254.14.488.366.608.1.054.21.08.32.08.137 0 .27-.04.387-.118l5.12-3.48 2.69-1.827c.328-.226.78-.14 1.006.193.223.33.137.782-.194 1.006l-2.212 1.504 3.834 2.604c.21.142.483.157.707.04.225-.12.366-.355.366-.61V.688c0-.38-.306-.687-.686-.687' fill='%23D6D6D6' fill-rule='evenodd'/%3E%3C/svg%3E\"); }\n\n.icon-bookmark-v2.icon-gray {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18'%3E%3Ctitle%3EFill 4%3C/title%3E%3Cpath d='M11.704 0H.688C.307 0 0 .308 0 .687v16.626c0 .254.14.488.366.608.1.054.21.08.32.08.137 0 .27-.04.387-.118l5.12-3.48 2.69-1.827c.328-.226.78-.14 1.006.193.223.33.137.782-.194 1.006l-2.212 1.504 3.834 2.604c.21.142.483.157.707.04.225-.12.366-.355.366-.61V.688c0-.38-.306-.687-.686-.687' fill='%23BFBFBF' fill-rule='evenodd'/%3E%3C/svg%3E\"); }\n\n.icon-bookmark-v2.icon-blue {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18'%3E%3Ctitle%3EFill 4%3C/title%3E%3Cpath d='M11.704 0H.688C.307 0 0 .308 0 .687v16.626c0 .254.14.488.366.608.1.054.21.08.32.08.137 0 .27-.04.387-.118l5.12-3.48 2.69-1.827c.328-.226.78-.14 1.006.193.223.33.137.782-.194 1.006l-2.212 1.504 3.834 2.604c.21.142.483.157.707.04.225-.12.366-.355.366-.61V.688c0-.38-.306-.687-.686-.687' fill='%236376EC' fill-rule='evenodd'/%3E%3C/svg%3E\"); }\n\n.icon-tds-chevron-left.icon-blue {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='34' height='34' viewBox='0 0 34 34'%3E  %3Cg fill='none' fill-rule='evenodd'%3E    %3Crect width='34' height='34' rx='4'/%3E    %3Cpath fill='%236376EC' d='M21.051546%2C10.6411794 C21.4386317%2C10.2540937 21.4520409%2C9.63991318 21.0814964%2C9.2693687 C20.710952%2C8.89882422 20.0967714%2C8.91223347 19.7096858%2C9.2993191 L12%2C17.0090049 L19.3802314%2C24.3892363 C19.7507759%2C24.7597807 20.3649564%2C24.7463715 20.752042%2C24.3592859 C21.1391277%2C23.9722002 21.1525369%2C23.3580197 20.7819924%2C22.9874752 L14.7436213%2C16.9491041 L21.051546%2C10.6411794 Z'/%3E  %3C/g%3E%3C/svg%3E\"); }\n\n.icon-tds-chevron-right.icon-blue {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='34' height='34' viewBox='0 0 34 34'%3E  %3Cg fill='none' fill-rule='evenodd'%3E    %3Crect width='34' height='34' rx='4'/%3E    %3Cpath fill='%236376EC' d='M12.2993191%2C23.0174256 C11.9122335%2C23.4045112 11.8988242%2C24.0186918 12.2693687%2C24.3892363 C12.6399132%2C24.7597807 13.2540937%2C24.7463715 13.6411794%2C24.3592859 L21.3508651%2C16.6496001 L13.9706337%2C9.2693687 C13.6000893%2C8.89882422 12.9859087%2C8.91223347 12.5988231%2C9.2993191 C12.2117375%2C9.68640472 12.1983282%2C10.3005853 12.5688727%2C10.6711298 L18.6072438%2C16.7095009 L12.2993191%2C23.0174256 Z'/%3E  %3C/g%3E%3C/svg%3E\"); }\n\n.rz {\n  margin-bottom: 16px; }\n\n.rz-list {\n  padding: 0 16px;\n  background-color: #ffffff; }\n  .rz-list li:last-child > a {\n    border-bottom: none;\n    padding-bottom: 16px; }\n\n.rz__title {\n  background-color: #ffffff;\n  font-weight: 500;\n  font-size: 16px;\n  margin-top: 0;\n  margin-bottom: 0;\n  padding: 10px 16px; }\n\n.rz__title--mint {\n  background-color: #00c7b1;\n  color: #ffffff; }\n\n.rz__title--pink {\n  background-color: #ef426f;\n  color: #ffffff; }\n\n.rz__text-container {\n  -ms-flex: 1;\n      flex: 1;\n  padding-right: 10px;\n  line-height: 104%; }\n\n.rz-image-container {\n  position: relative;\n  width: 94px;\n  height: 70px;\n  overflow: hidden;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center; }\n\n.rz-list__item {\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n  padding: 8px 0;\n  border-bottom: 1px solid #ebebeb; }\n\n.rz-list__item-title {\n  font-size: 14px;\n  font-weight: 500;\n  margin-top: 0;\n  margin-bottom: 0; }\n\n.rz-list__item-text {\n  font-size: 14px;\n  margin-top: 0;\n  margin-bottom: 0; }\n\n.l-inline {\n  display: inline; }\n\n.rz-job__img-container {\n  overflow: hidden;\n  position: relative;\n  padding-bottom: 31.3%;\n  background-color: #ffffff; }\n\n.rz-job__body {\n  padding: 8px 16px 14px 16px;\n  background-color: #ffffff;\n  border-bottom: 1px solid #ebebeb; }\n\n.rz-job__feature {\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n  padding: 16px 0; }\n\n.rz-job__feature-title {\n  font-weight: 500;\n  font-size: 20px;\n  margin-top: 0;\n  margin-bottom: 0;\n  letter-spacing: -0.035rem; }\n\n.rz-job__feature-location {\n  font-size: 14px;\n  margin-top: 6px;\n  margin-bottom: 0; }\n\n.rz-job__feature-description {\n  font-size: 14px;\n  line-height: 1.2; }\n\n.rz__feature-button-container {\n  position: relative;\n  padding-top: 14px;\n  line-height: 1.5; }\n  .rz__feature-button-container:before, .rz__feature-button-container:after {\n    content: \" \";\n    display: table; }\n  .rz__feature-button-container:after {\n    clear: both; }\n\n.rz-job__feature-expiry {\n  font-size: 14px;\n  font-weight: 500;\n  letter-spacing: -0.01rem; }\n\n.rz-community__card {\n  background-color: #fff4ef;\n  padding: 30px 18px 32px 18px; }\n\n.rz-community__text-container {\n  padding-top: 8px;\n  text-align: left; }\n\n.rz-community__text-title {\n  font-size: 22px;\n  font-weight: 500;\n  margin-bottom: 5px; }\n\n.rz-community__text-description {\n  font-size: 18px;\n  line-height: 1.4;\n  color: #222222; }\n\n.rz-institute__course-duration {\n  font-size: 15px;\n  letter-spacing: -0.02rem; }\n\n.rz__label {\n  display: inline-block;\n  padding: 4px 6px;\n  line-height: 1;\n  text-transform: uppercase;\n  font-size: 11px;\n  font-weight: 500;\n  border-radius: 2px;\n  color: #ffffff;\n  background-color: #58657f; }\n\n.rz__label--resource {\n  background-color: #ef426f; }\n\n.rz__label--positions {\n  background-color: #002e5d; }\n\n.rz__label--targeted {\n  background-color: #002e5d; }\n\n.rz__label--community {\n  background-color: #6376ec; }\n\n.rz__label--institute {\n  background-color: #002e5d; }\n\n.rz-rating {\n  display: inline-block;\n  position: relative;\n  padding-right: 5px; }\n\n.rz-rating__icon {\n  margin-right: 2px; }\n\n.rz-rating__count {\n  padding-left: 3px;\n  line-height: 1;\n  font-size: 0.70588rem;\n  color: inherit; }\n\n.rz-rating__stars {\n  display: inline-block;\n  position: relative;\n  z-index: 1; }\n\n.rz-rating__disabled-stars {\n  position: absolute;\n  z-index: 0;\n  left: 0;\n  top: 0; }\n\n.rz-quick-apply-label {\n  display: inline-block;\n  padding: 0px 7px;\n  margin-right: 5px;\n  border-radius: 12px;\n  background-color: #ccf0f9;\n  color: #0090b4;\n  text-transform: uppercase;\n  font-size: 10px;\n  font-weight: 500;\n  vertical-align: middle;\n  line-height: 14px; }\n\n.rz-card {\n  position: relative;\n  line-height: 1;\n  background-color: #ffffff;\n  border: 1px solid #d2d6d9;\n  border-radius: 4px; }\n\n.rz-card__image-container {\n  padding-bottom: 68.6956521739%;\n  background-color: #edf7fb;\n  overflow: hidden;\n  border-radius: 4px 4px 0 0; }\n\n.rz-card__image-container--small {\n  padding-bottom: 46.5217391304%; }\n\n.rz-card__body {\n  min-height: 190px;\n  padding: 12px 16px;\n  color: #222222;\n  border-radius: inherit; }\n\n.rz-card__body--sm {\n  min-height: 77px; }\n\n.rz-card__body--no-border {\n  margin: -1px; }\n\n.rz-card__body--no-bottom-radius,\n.rz-card__image-container {\n  border-radius: 4px 4px 0 0; }\n\n.rz-card__headline {\n  margin-top: 0;\n  margin-bottom: 5px;\n  font-size: 17px;\n  font-weight: 500;\n  line-height: 1.11;\n  -ms-flex-item-align: center;\n      -ms-grid-row-align: center;\n      align-self: center; }\n  @media screen and (min-width: 744px) {\n    .rz-card__headline {\n      font-size: 14px;\n      line-height: 1.2; } }\n\n.rz-card__headline--lg {\n  line-height: 1.1;\n  font-size: 22px; }\n\n.rz-card__description {\n  margin: 0 0 5px 0;\n  padding: 0;\n  font-size: 14px;\n  line-height: 1.45; }\n\n.rz-card__author {\n  margin: 0;\n  padding-left: 8px;\n  font-size: 12px;\n  line-height: 1.25;\n  letter-spacing: -0.02rem; }\n\n.rz-card__footer {\n  position: relative;\n  padding: 10px 10px;\n  font-size: 14px;\n  line-height: 1;\n  display: -ms-flexbox;\n  display: flex; }\n\n.rz-card__rating {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  font-size: 12px; }\n\n.rz-card__prices {\n  -ms-flex: 1 1 auto;\n      flex: 1 1 auto;\n  display: inline-block;\n  line-height: 1.1;\n  font-size: 14px;\n  font-weight: 500;\n  letter-spacing: -0.02rem; }\n  @media screen and (min-width: 744px) {\n    .rz-card__prices {\n      font-size: 12px; } }\n\n.rz-card__price {\n  color: #002e5d; }\n\n.rz-card__price--strike {\n  text-decoration: line-through;\n  margin-right: 8px; }\n\n.rz-card__discount-price {\n  color: #fd7037; }\n\n.rz-card__save {\n  -ms-flex-item-align: end;\n      align-self: flex-end; }\n\n.rz-card__body--color-0 {\n  background-color: #00c7b1;\n  color: #ffffff; }\n\n.rz-card__body--color-1 {\n  background-color: #005a70;\n  color: #ffffff; }\n\n.rz-card__body--color-2 {\n  background-color: #753bbd;\n  color: #ffffff; }\n\n.rz-card__body--color-3 {\n  background-color: #43526f;\n  color: #ffffff; }\n\n.rz-card__body--color-4 {\n  background-color: #2b3547;\n  color: #ffffff; }\n\n.rz-save-for-later {\n  line-height: 1.1;\n  font-size: 14px;\n  color: #b3b8bd;\n  text-decoration: none; }\n  @media screen and (min-width: 744px) {\n    .rz-save-for-later {\n      font-size: 12px; } }\n  .rz-save-for-later:hover {\n    color: #5c656e;\n    text-decoration: none; }\n\n.rz-save-for-later__icon {\n  margin-top: -3px;\n  margin-left: 4px; }\n\n.rz-tooltip {\n  display: none; }\n  .rz-tooltip .rz-overlay {\n    z-index: 50;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    opacity: 0;\n    visibility: visible;\n    width: 100%;\n    background-color: #222;\n    transition: visibility 0s linear .15s,opacity .15s linear;\n    left: 0;\n    position: fixed; }\n  .rz-tooltip.active {\n    display: block; }\n    .rz-tooltip.active .rz-overlay {\n      opacity: .5; }\n  .rz-tooltip .rz-box {\n    background-color: #fff;\n    position: absolute;\n    z-index: 100;\n    top: 16px;\n    left: 16px; }\n    .rz-tooltip .rz-box .rz-arrow {\n      position: absolute;\n      width: 0;\n      height: 0;\n      border-style: solid;\n      border-width: 15px 10px 15px 0px;\n      top: 0;\n      left: -5px;\n      background: transparent;\n      margin-left: -5px;\n      border-color: transparent;\n      border-right-color: #fccf34; }\n    .rz-tooltip .rz-box.left .rz-arrow {\n      left: initial;\n      right: -10px;\n      border-width: 15px 0px 15px 10px;\n      border-right-color: transparent;\n      border-left-color: #fccf34; }\n    .rz-tooltip .rz-box .rz-tooltip__text-title {\n      background-color: #fccf34;\n      padding: 7px 15px;\n      font-weight: 500; }\n      .rz-tooltip .rz-box .rz-tooltip__text-title .rz-tooltip-close {\n        cursor: pointer;\n        font-size: 24px;\n        line-height: 24px; }\n    .rz-tooltip .rz-box .rz-tooltip__text-description {\n      padding: 7px 15px;\n      max-width: 400px; }\n\n.rz-modal {\n  display: block;\n  position: fixed;\n  z-index: 99;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  background-color: black;\n  background-color: rgba(0, 0, 0, 0.4); }\n\n.rz-modal-content {\n  margin: 5% auto;\n  padding: 20px;\n  border: 1px solid #888;\n  border-radius: 4px;\n  background-color: #FFFFFF;\n  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.15), 0 5px 20px 0 rgba(0, 0, 0, 0.1);\n  position: relative;\n  width: 80%;\n  max-width: 750px; }\n\n.rz-modal-inner-content {\n  padding: 30px; }\n\n.rz-modal-content h2 {\n  height: 27px;\n  color: #222222;\n  font-size: 22px;\n  font-weight: 500;\n  line-height: 27px;\n  text-align: center;\n  margin: 0 auto; }\n\n.rz-modal-content p {\n  color: #43526F;\n  font-size: 15px;\n  line-height: 18px;\n  text-align: center;\n  width: 100%; }\n\n.rz-modal-content section {\n  margin-bottom: 0px; }\n\n.rz-modal-content .tes-btn {\n  color: #FFFFFF;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 16px; }\n\n.rz-modal-close {\n  color: #B3B8BD;\n  font-size: 28px;\n  font-weight: 500;\n  position: absolute;\n  top: 5px;\n  right: 15px; }\n\n.rz-modal-close:hover,\n.rz-modal-close:focus {\n  color: black;\n  text-decoration: none;\n  cursor: pointer; }\n\n.rz-little-modal-outer {\n  width: 500px;\n  margin: 15% auto;\n  padding: 20px;\n  border: 1px solid #888;\n  border-radius: 4px;\n  background-color: #FFFFFF;\n  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.15), 0 5px 20px 0 rgba(0, 0, 0, 0.1);\n  position: relative; }\n\n.rz-little-modal-inner {\n  padding: 0px; }\n\n.little-modal-text h2 {\n  font-size: 22px;\n  font-weight: 500;\n  line-height: 27px;\n  text-align: center;\n  margin-top: 10px; }\n\n.little-modal-text p {\n  font-size: 15px;\n  line-height: 18px;\n  text-align: center; }\n\n.little-modal-cta .tes-btn {\n  width: 180px; }\n\n.little-modal-cta .cta-link {\n  width: 180px;\n  color: #6376EC;\n  font-size: 15px;\n  line-height: 18px; }\n\n[data-rz] .collapsible {\n  position: relative;\n  overflow: hidden; }\n\n[data-rz] .collapsible__button {\n  position: absolute;\n  top: 8px;\n  right: 16px;\n  border-radius: 4px;\n  transition: background-color 100ms ease;\n  cursor: pointer; }\n\n[data-rz] .collapsible__button:hover {\n  background-color: rgba(128, 128, 128, 0.1); }\n\n[data-rz] .collapsible__icon {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='34' height='34' viewBox='0 0 34 34'%3E  %3Cg fill='none' fill-rule='evenodd'%3E    %3Crect width='34' height='34' rx='4'/%3E    %3Cpath fill='%236376EC' d='M10.6711298%2C12.5688727 C10.3005853%2C12.1983282 9.68640472%2C12.2117375 9.2993191%2C12.5988231 C8.91223347%2C12.9859087 8.89882422%2C13.6000893 9.2693687%2C13.9706337 L16.6496001%2C21.3508651 L24.3592859%2C13.6411794 C24.7463715%2C13.2540937 24.7597807%2C12.6399132 24.3892363%2C12.2693687 C24.0186918%2C11.8988242 23.4045112%2C11.9122335 23.0174256%2C12.2993191 L16.7095009%2C18.6072438 L10.6711298%2C12.5688727 Z'/%3E  %3C/g%3E%3C/svg%3E\");\n  transition: transform 200ms ease;\n  transform: rotateZ(180deg); }\n\n[data-rz] .collapsible__toggle {\n  display: none; }\n\n[data-rz] .collapsible__content {\n  background-color: white;\n  max-height: 1800px;\n  transition: max-height 200ms ease;\n  overflow: hidden; }\n\n[data-rz] .collapsible__toggle:checked + .collapsible .collapsible__content {\n  max-height: 40px; }\n\n[data-rz] .collapsible__toggle:checked + .collapsible .collapsible__icon {\n  transform: rotateZ(0); }\n\n[data-rz] .cms-faq__icon {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='34' height='34' viewBox='0 0 34 34'%3E  %3Cpath fill='%23666666' fill-rule='evenodd' d='M24.069%2C9.929 C25.959%2C11.819 27%2C14.327 27%2C17 C27%2C19.671 25.959%2C22.179 24.069%2C24.069 C22.181%2C25.959 19.672%2C27 17%2C27 C14.328%2C27 11.819%2C25.959 9.931%2C24.069 C8.041%2C22.179 7%2C19.671 7%2C17 C7%2C14.327 8.041%2C11.819 9.931%2C9.929 C11.819%2C8.04 14.328%2C7 17%2C7 C19.672%2C7 22.181%2C8.04 24.069%2C9.929 Z M17%2C25.524 C21.701%2C25.524 25.524%2C21.7 25.524%2C17 C25.524%2C12.298 21.701%2C8.474 17%2C8.474 C12.299%2C8.474 8.476%2C12.298 8.476%2C17 C8.476%2C21.7 12.299%2C25.524 17%2C25.524 Z M17%2C20.4273 C17.69%2C20.4273 18.25%2C20.9873 18.25%2C21.6773 C18.25%2C22.3663 17.69%2C22.9273 17%2C22.9273 C16.31%2C22.9273 15.75%2C22.3663 15.75%2C21.6773 C15.75%2C20.9873 16.31%2C20.4273 17%2C20.4273 Z M16.8613%2C10.9888 C18.9223%2C10.9888 20.5353%2C12.3508 20.5353%2C14.0908 C20.5353%2C14.8608 20.2363%2C15.5988 19.7153%2C16.1148 C19.2493%2C16.5748 18.6513%2C16.7988 17.9993%2C16.8068 L17.9203%2C16.8068 C17.7443%2C16.8388 17.6733%2C16.9178 17.7023%2C17.7798 C17.7073%2C17.9118 17.7113%2C18.0428 17.7113%2C18.1678 C17.7113%2C18.5678 17.3863%2C18.8918 16.9863%2C18.8918 C16.5863%2C18.8918 16.2613%2C18.5678 16.2613%2C18.1678 C16.2613%2C18.0578 16.2573%2C17.9448 16.2533%2C17.8298 C16.2283%2C17.1038 16.1753%2C15.5928 17.7603%2C15.3648 C17.7953%2C15.3598 17.8303%2C15.3578 17.8643%2C15.3578 L18.0073%2C15.3578 C18.2803%2C15.3658 18.5083%2C15.2678 18.6953%2C15.0838 C18.9393%2C14.8428 19.0863%2C14.4698 19.0863%2C14.0908 C19.0863%2C13.1638 18.1083%2C12.4378 16.8613%2C12.4378 C15.6343%2C12.4378 14.6363%2C13.4358 14.6363%2C14.6628 C14.6363%2C15.0628 14.3123%2C15.3868 13.9123%2C15.3868 C13.5113%2C15.3868 13.1873%2C15.0628 13.1873%2C14.6628 C13.1873%2C12.6358 14.8353%2C10.9888 16.8613%2C10.9888 Z'/%3E%3C/svg%3E\"); }\n\n[data-rz] .cms-faq__title {\n  height: 40px;\n  padding-top: 3px;\n  padding-left: 10px; }\n  [data-rz] .cms-faq__title span {\n    vertical-align: middle;\n    font-weight: 500;\n    line-height: 1; }\n\n[data-rz] .cms-faq__content {\n  margin: 0px 16px;\n  border-top: 1px #d6d6d6 solid;\n  padding: 10px 0;\n  font-size: 0.82353rem; }\n  [data-rz] .cms-faq__content p {\n    margin: 0; }\n\n[data-rz] .cms-faq__group + .cms-faq__group {\n  border-top: 1px #d6d6d6 solid; }\n\n[data-rz] .cms-faq__group {\n  padding: 10px 0; }\n\n[data-rz] .cms-faq__a {\n  margin-top: 5px;\n  font-weight: 500; }\n\n[data-rz] .cms-faq__a:before {\n  display: inline;\n  content: 'Answer: ';\n  color: #00b5e2;\n  float: left;\n  margin-right: 5px; }\n\n[data-rz] .cms-intro__icon {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='34' height='34' viewBox='0 0 34 34'%3E  %3Cpath fill='%23666666' fill-rule='evenodd' d='M17%2C25.524 C12.299%2C25.524 8.476%2C21.701 8.476%2C17 C8.476%2C12.299 12.299%2C8.475 17%2C8.475 C21.701%2C8.475 25.525%2C12.299 25.525%2C17 C25.525%2C21.701 21.701%2C25.524 17%2C25.524 M24.07%2C9.93 C25.959%2C11.82 27%2C14.328 27%2C17 C27%2C19.672 25.959%2C22.18 24.07%2C24.07 C22.181%2C25.959 19.672%2C27 17%2C27 C14.328%2C27 11.82%2C25.959 9.931%2C24.07 C8.041%2C22.18 7%2C19.672 7%2C17 C7%2C14.328 8.041%2C11.82 9.931%2C9.93 C11.82%2C8.041 14.328%2C7 17%2C7 C19.672%2C7 22.181%2C8.041 24.07%2C9.93 Z M17.2505%2C15.8433 L15.5005%2C15.8433 C15.0855%2C15.8433 14.7505%2C16.1793 14.7505%2C16.5933 C14.7505%2C17.0073 15.0855%2C17.3433 15.5005%2C17.3433 L16.5005%2C17.3433 L16.4995%2C22.9043 C16.4995%2C23.3183 16.8345%2C23.6543 17.2495%2C23.6543 C17.6635%2C23.6543 17.9995%2C23.3183 17.9995%2C22.9043 L18.0005%2C16.5933 C18.0005%2C16.3943 17.9215%2C16.2033 17.7805%2C16.0633 C17.6405%2C15.9223 17.4495%2C15.8433 17.2505%2C15.8433 Z M17%2C11.399 C16.31%2C11.399 15.75%2C11.96 15.75%2C12.649 C15.75%2C13.339 16.31%2C13.899 17%2C13.899 C17.69%2C13.899 18.25%2C13.339 18.25%2C12.649 C18.25%2C11.96 17.69%2C11.399 17%2C11.399 Z'/%3E%3C/svg%3E\"); }\n\n[data-rz] .cms-intro__title {\n  height: 40px;\n  padding-top: 3px;\n  padding-left: 10px; }\n  [data-rz] .cms-intro__title span {\n    vertical-align: middle;\n    font-weight: 500;\n    line-height: 1; }\n\n[data-rz] .cms-intro__content {\n  margin: 0px 16px;\n  border-top: 1px #d6d6d6 solid;\n  padding: 10px 0;\n  font-size: 0.82353rem; }\n\n[data-rz] .tds-btn {\n  font-family: inherit;\n  display: inline-block;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  text-decoration: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  -webkit-appearance: none;\n  white-space: nowrap;\n  border-style: none;\n  margin: 0;\n  border-style: none;\n  cursor: pointer;\n  font-weight: 500;\n  -ms-touch-action: manipulation;\n      touch-action: manipulation;\n  line-height: 34px;\n  height: 34px;\n  font-size: 0.82353rem;\n  padding: 0 17px;\n  border-radius: 4px 4px 0 4px;\n  color: inherit;\n  background-color: white;\n  box-shadow: 0 0 0 2px currentColor inset;\n  white-space: pre; }\n  [data-rz] .tds-btn:focus, [data-rz] .tds-btn:hover {\n    text-decoration: none;\n    background-color: #f5f5f5; }\n  [data-rz] .tds-btn:active, [data-rz] .tds-btn:hover {\n    outline: 0;\n    text-decoration: none; }\n  [data-rz] .tds-btn:active {\n    background-color: gainsboro; }\n\n[data-rz] .tds-btn--primary {\n  box-shadow: none;\n  color: white;\n  background-color: #6376ec; }\n  [data-rz] .tds-btn--primary:focus, [data-rz] .tds-btn--primary:hover {\n    color: white;\n    background-color: #4f5ebc; }\n  [data-rz] .tds-btn--primary:active {\n    background-color: #3c499c; }\n\n[data-rz] .tds-btn--primary-dark {\n  box-shadow: none;\n  color: #6376ec;\n  background-color: white; }\n  [data-rz] .tds-btn--primary-dark:focus, [data-rz] .tds-btn--primary-dark:hover {\n    background-color: #f5f5f5; }\n  [data-rz] .tds-btn--primary-dark:active {\n    background-color: gainsboro; }\n\n[data-rz] .tds-btn--secondary {\n  color: #005a70; }\n\n[data-rz] .tds-btn--secondary-dark {\n  color: white;\n  background-color: transparent; }\n  [data-rz] .tds-btn--secondary-dark:focus, [data-rz] .tds-btn--secondary-dark:hover {\n    background-color: rgba(255, 255, 255, 0.1); }\n  [data-rz] .tds-btn--secondary-dark:active {\n    background-color: rgba(255, 255, 255, 0); }\n\n[data-rz] .tds-btn--neutral {\n  color: #666666;\n  box-shadow: 0 0 0 1px #bfbfbf inset; }\n\n[data-rz] .tds-btn--neutral-dark {\n  color: white;\n  box-shadow: 0 0 0 1px currentColor inset;\n  background-color: transparent; }\n  [data-rz] .tds-btn--neutral-dark:focus, [data-rz] .tds-btn--neutral-dark:hover {\n    background-color: rgba(255, 255, 255, 0.1); }\n  [data-rz] .tds-btn--neutral-dark:active {\n    background-color: rgba(255, 255, 255, 0); }\n\n[data-rz] .tds-btn--link,\n[data-rz] .tds-btn--link-red,\n[data-rz] .tds-btn--link-dark {\n  background-color: transparent;\n  box-shadow: none; }\n\n[data-rz] .tds-btn--link {\n  color: #6376ec; }\n\n[data-rz] .tds-btn--link-red {\n  color: #ef426f; }\n\n[data-rz] .tds-btn--link-dark {\n  color: white; }\n  [data-rz] .tds-btn--link-dark:hover, [data-rz] .tds-btn--link-dark:focus, [data-rz] .tds-btn--link-dark:active {\n    color: #d6d6d6;\n    background-color: transparent; }\n\n[data-rz] .tds-btn--icon {\n  padding: 0 7px;\n  box-shadow: none;\n  background-color: transparent; }\n\n[data-rz] .tds-btn--icon-left,\n[data-rz] .tds-btn--icon-right,\n[data-rz] .tds-btn--icon-rounded {\n  box-shadow: 0 0 0 1px #bfbfbf inset;\n  padding: 0 7px;\n  border-radius: 50%; }\n  [data-rz] .tds-btn--icon-left:focus,\n  [data-rz] .tds-btn--icon-right:focus,\n  [data-rz] .tds-btn--icon-rounded:focus {\n    outline: 0;\n    box-shadow: 0 0 0 1px #bfbfbf inset, 0 0 1px 1px #fff, 0 0 2px 3px #87bffe; }\n\n[data-rz] .tds-btn--icon-left {\n  border-bottom-left-radius: 0; }\n\n[data-rz] .tds-btn--icon-right {\n  border-bottom-right-radius: 0; }\n\n[data-rz] .tds-btn--sm {\n  padding: 0 12px;\n  line-height: 24px;\n  height: 24px;\n  font-size: 0.76471rem; }\n\n[data-rz] .tds-btn--lg {\n  line-height: 44px;\n  height: 44px;\n  padding: 0 22px;\n  font-size: 1.05882rem; }\n\n[data-rz] .tds-btn--xl {\n  line-height: 54px;\n  height: 54px;\n  padding: 0 27px;\n  font-size: 1.29412rem; }\n\n[data-rz] .tds-btn--block {\n  text-align: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  width: 100%; }\n\n[data-rz] .tds-btn--is-disabled, [data-rz] .tds-btn:disabled {\n  pointer-events: none;\n  opacity: 0.3; }\n\n[data-rz] .tds-btn.tds-btn--loading {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-align: center;\n      align-items: center; }\n  [data-rz] .tds-btn.tds-btn--loading:disabled {\n    opacity: .6; }\n  [data-rz] .tds-btn.tds-btn--loading .icon-loading-spinner {\n    width: 16px;\n    height: 16px;\n    margin-right: 10px;\n    animation: tds-loader-spin .5s infinite linear, tds-loader-spin-enter .3s;\n    background-image: url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%0D%3C!-- Generator: Adobe Illustrator 18.1.1%2C SVG Export Plug-In . SVG Version: 6.00 Build 0)  --%3E%0D%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px'%0D%09 viewBox='475 -301.4 1792 1792' enable-background='new 475 -301.4 1792 1792' xml:space='preserve'%3E%0D%3Cg opacity='0.5'%3E%0D%09%3Cpath fill='%23BFBFBF' d='M1371.3-203.9c107.5%2C0%2C211.7%2C21%2C309.7%2C62.5c47.1%2C19.9%2C92.6%2C44.6%2C135.1%2C73.3c42.2%2C28.5%2C81.8%2C61.2%2C117.8%2C97.2%0D%09%09c36%2C36%2C68.7%2C75.7%2C97.2%2C117.8c28.7%2C42.5%2C53.4%2C88%2C73.3%2C135.1c41.5%2C98%2C62.5%2C202.2%2C62.5%2C309.7s-21%2C211.7-62.5%2C309.7%0D%09%09c-19.9%2C47.1-44.6%2C92.6-73.3%2C135.1c-28.5%2C42.2-61.2%2C81.8-97.2%2C117.8c-36%2C36-75.7%2C68.7-117.8%2C97.2c-42.5%2C28.7-88%2C53.4-135.1%2C73.3%0D%09%09c-98%2C41.5-202.2%2C62.5-309.7%2C62.5s-211.7-21-309.7-62.5c-47.1-19.9-92.6-44.6-135.1-73.3c-42.2-28.5-81.8-61.2-117.8-97.2%0D%09%09c-36-36-68.7-75.7-97.2-117.8c-28.7-42.5-53.4-88-73.3-135.1c-41.5-98-62.5-202.2-62.5-309.7s21-211.7%2C62.5-309.7%0D%09%09c19.9-47.1%2C44.6-92.6%2C73.3-135.1c28.5-42.2%2C61.2-81.8%2C97.2-117.8c36-36%2C75.7-68.7%2C117.8-97.2c42.5-28.7%2C88-53.4%2C135.1-73.3%0D%09%09C1159.6-182.9%2C1263.8-203.9%2C1371.3-203.9 M1371.3-303.9c-494.7%2C0-895.7%2C401-895.7%2C895.7s401%2C895.7%2C895.7%2C895.7%0D%09%09s895.7-401%2C895.7-895.7S1866-303.9%2C1371.3-303.9L1371.3-303.9z'/%3E%0D%3C/g%3E%0D%3Cpath fill='none' stroke='%23BFBFBF' stroke-width='100' stroke-linejoin='round' stroke-miterlimit='10' d='M1371.3-253.4%0D%09c468.2%2C0%2C847.7%2C379.5%2C847.7%2C847.7'/%3E%0D%3C/svg%3E%0D\"); }\n  [data-rz] .tds-btn.tds-btn--loading > span {\n    animation: tds-loader-text .3s ease-out; }\n\n@keyframes tds-loader-spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes tds-loader-spin-enter {\n  0% {\n    width: 0; }\n  100% {\n    width: 16px; } }\n\n@keyframes tds-loader-text {\n  0% {\n    transform: translate3d(-10px, 0, 0);\n    opacity: 0; }\n  100% {\n    transform: translate3d(0, 0, 0);\n    opacity: 1; } }\n\n[data-rz] .cms-cta {\n  overflow: hidden;\n  border-radius: 4px 4px 0 4px; }\n\n[data-rz] .cms-cta__img-wrapper {\n  position: relative;\n  z-index: 1; }\n\n[data-rz] .cms-cta__subtext {\n  font-size: 0.82353rem;\n  margin-top: 12px; }\n\n[data-rz] .cms-cta__img-placeholder {\n  font-size: 0.82353rem;\n  line-height: 1.1;\n  border-radius: 4px;\n  background-color: rgba(255, 255, 255, 0.3);\n  color: white;\n  text-transform: uppercase;\n  max-height: 80px;\n  width: 100px;\n  padding: 8px;\n  position: absolute;\n  top: 70px;\n  right: 15px; }\n\n[data-rz] .cms-cta__content {\n  padding: 24px 16px 36px; }\n\n[data-rz] .cms-cta__text {\n  font-size: 1.41176rem;\n  font-weight: 500;\n  line-height: 1.1; }\n\n[data-rz] .cms-cta__button-wrapper {\n  margin-top: 24px; }\n\n[data-rz] .cms-cta--type-primary {\n  background-color: #00b5e2; }\n  [data-rz] .cms-cta--type-primary .cms-cta__content {\n    color: white; }\n  [data-rz] .cms-cta--type-primary.cms-cta--theme-french-rose {\n    background-color: #ef426f; }\n  [data-rz] .cms-cta--type-primary.cms-cta--theme-purple-heart {\n    background-color: #753bbd; }\n  [data-rz] .cms-cta--type-primary.cms-cta--theme-burning-orange {\n    background-color: #fd7037; }\n  [data-rz] .cms-cta--type-primary.cms-cta--theme-caribbean-green {\n    background-color: #00c7b1; }\n  [data-rz] .cms-cta--type-primary.cms-cta--theme-cornflower-blue {\n    background-color: #6376ec; }\n  [data-rz] .cms-cta--type-primary.cms-cta--theme-pacific-blue {\n    background-color: #0095c8; }\n  [data-rz] .cms-cta--type-primary.cms-cta--theme-broom {\n    background-color: #ffe324; }\n    [data-rz] .cms-cta--type-primary.cms-cta--theme-broom .cms-cta__content {\n      color: #222222; }\n  [data-rz] .cms-cta--type-primary.cms-cta--theme-electric-lime {\n    background-color: #d0df00; }\n    [data-rz] .cms-cta--type-primary.cms-cta--theme-electric-lime .cms-cta__content {\n      color: #222222; }\n\n[data-rz] .cms-cta--type-secondary {\n  background-color: white;\n  color: #666666; }\n  [data-rz] .cms-cta--type-secondary .cms-cta__subtext {\n    color: #666666; }\n  [data-rz] .cms-cta--type-secondary.cms-cta--theme-cerulian {\n    color: #00b5e2; }\n  [data-rz] .cms-cta--type-secondary.cms-cta--theme-french-rose {\n    color: #ef426f; }\n  [data-rz] .cms-cta--type-secondary.cms-cta--theme-purple-heart {\n    color: #753bbd; }\n  [data-rz] .cms-cta--type-secondary.cms-cta--theme-burning-orange {\n    color: #fd7037; }\n  [data-rz] .cms-cta--type-secondary.cms-cta--theme-caribbean-green {\n    color: #00c7b1; }\n  [data-rz] .cms-cta--type-secondary.cms-cta--theme-cornflower-blue {\n    color: #6376ec; }\n  [data-rz] .cms-cta--type-secondary.cms-cta--theme-pacific-blue {\n    color: #0095c8; }\n\n[data-rz] .cms-cta__survey-column {\n  float: left;\n  height: 50px;\n  width: 50px;\n  margin-right: 16px;\n  background-repeat: no-repeat;\n  background-size: 66px;\n  background-position: center;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='34' height='34' viewBox='0 0 34 34'%3E  %3Cpath fill='%23FFFFFF' d='M24.109462%2C14.1681564 L20.4434137%2C14.1681564 L20.4434137%2C11.4451435 C20.4434137%2C10.1018986 20.0556586%2C9.12794464 19.2879819%2C8.54357225 C18.0816327%2C7.62643227 16.4444444%2C8.14181624 16.3739435%2C8.16616509 L15.880437%2C8.32849075 L15.880437%2C12.2040159 C15.880437%2C13.1414466 15.3869305%2C13.9733656 14.4116677%2C14.6835404 C14.0944135%2C14.9148545 14.0160792%2C15.3693663 14.2393321%2C15.7021339 C14.462585%2C16.0308434 14.9012575%2C16.1120062 15.2224284%2C15.8806922 C16.5776129%2C14.8945638 17.2943723%2C13.6243655 17.2943723%2C12.2040159 L17.2943723%2C9.46477038 C17.6468769%2C9.43230525 18.1129664%2C9.4566541 18.4576376%2C9.71637516 C18.841476%2C10.0085614 19.0373119%2C10.5888756 19.0373119%2C11.4370272 L19.0373119%2C15.6209711 L24.1133787%2C15.6209711 C24.9163059%2C15.6209711 25.5703979%2C16.2824482 25.5938982%2C17.1103091 L24.540301%2C23.9645101 L24.5363843%2C23.988859 C24.4893836%2C24.3703243 24.3522985%2C25.5350109 22.6367759%2C25.5350109 L14.7367553%2C25.5350109 C13.9612451%2C25.5350109 13.3306535%2C24.8816501 13.3306535%2C24.0781381 L13.3306535%2C17.3010417 C13.3306535%2C16.0633085 12.3593074%2C15.0528313 11.1607916%2C15.0528313 L10.1698619%2C15.0528313 C8.97526283%2C15.0528313 8%2C16.0592504 8%2C17.3010417 L8%2C24.2526382 C8%2C25.4903713 8.97134611%2C26.5008486 10.1698619%2C26.5008486 C10.557617%2C26.5008486 10.8748712%2C26.1721391 10.8748712%2C25.7703831 C10.8748712%2C25.3686271 10.557617%2C25.0399176 10.1698619%2C25.0399176 C9.75077304%2C25.0399176 9.41001855%2C24.6868593 9.41001855%2C24.2526382 L9.41001855%2C17.3010417 C9.41001855%2C16.8668206 9.75077304%2C16.5137622 10.1698619%2C16.5137622 L11.1607916%2C16.5137622 C11.5798804%2C16.5137622 11.9206349%2C16.8668206 11.9206349%2C17.3010417 L11.9206349%2C24.2526382 C11.9206349%2C24.3094522 11.9284684%2C24.3703243 11.9402185%2C24.4230801 C12.1047207%2C25.8718367 13.295403%2C27 14.7367553%2C27 L22.6289425%2C27 C23.427953%2C27 24.1407957%2C26.8011511 24.6813028%2C26.4237439 C25.3784787%2C25.9408251 25.8093177%2C25.16572 25.9268192%2C24.1836498 L26.9882498%2C17.2888673 C26.9960833%2C17.2482859 27%2C17.2036463 27%2C17.1630649 C27%2C15.5114013 25.7035663%2C14.1681564 24.109462%2C14.1681564 Z'/%3E%3C/svg%3E\"); }\n\n[data-rz] .cms-cta__survey-column ~ * {\n  margin-left: 66px; }\n\n[data-rz] .cms-cta--survey {\n  box-shadow: 0px 2px 6px #bfbfbf; }\n  [data-rz] .cms-cta--survey .cms-cta__content {\n    padding-bottom: 24px; }\n  [data-rz] .cms-cta--survey .cms-cta__text {\n    font-size: 1.05882rem; }\n\n[data-rz] .cms-supply-cta {\n  background: #ffffff; }\n\n[data-rz] .cms-supply-cta__img {\n  width: 300px;\n  height: 168px;\n  overflow: hidden;\n  text-indent: -100%;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: top center; }\n\n[data-rz] .cms-supply-cta__content {\n  padding: 16px 16px 22px 16px; }\n\n[data-rz] .cms-supply-cta__title {\n  font-weight: bold;\n  font-size: 1.29412rem;\n  color: #222222; }\n  [data-rz] .cms-supply-cta__title:before {\n    content: 'SUPPLY TEACHING';\n    display: block;\n    border-radius: 4px;\n    background-color: #00b5e2;\n    color: white;\n    font-size: 0.76471rem;\n    width: 135px;\n    text-align: center;\n    margin-bottom: 10px; }\n\n[data-rz] .cms-supply-cta__text {\n  font-size: 0.82353rem;\n  color: #666666;\n  padding: 10px 0 10px 0; }\n  [data-rz] .cms-supply-cta__text p {\n    margin: 0; }\n\n[data-rz] .cms-supply-cta__contact {\n  padding-top: 14px;\n  border-top: 1px solid #d6d6d6; }\n\n[data-rz] .cms-supply-cta__link, [data-rz] .cms-supply-cta__phone {\n  display: inline-block;\n  width: 50%; }\n\n[data-rz] .cms-supply-cta__phone {\n  color: #4c4c4c;\n  font-size: 0.82353rem; }\n\n[data-rz] .cms-supply-cta__phone-icon {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='34' height='34' viewBox='0 0 34 34'%3E  %3Cpath fill='%234C4C4C' d='M23.2802044%2C22.0243324 C24.0852246%2C22.8426447 24.0893319%2C24.0022631 23.2802044%2C24.8452481 C23.2760972%2C24.8493602 23.2719899%2C24.8534723 23.2678827%2C24.8575845 L22.0110654%2C26.1158938 C21.4976597%2C26.629909 20.8733583%2C26.9218697 20.1545902%2C26.9835515 L20.150483%2C26.9835515 C20.0190511%2C26.9958879 19.8876192%2C27 19.7602946%2C27 C18.7909845%2C27 17.9161411%2C26.7203757 17.3164832%2C26.4983211 C15.6859066%2C25.8938392 14.17444%2C24.9850602 12.5602924%2C23.6445085 C10.6093505%2C22.0078839 9.0732405%2C20.0422897 7.98482031%2C17.7970711 L7.98482031%2C17.7929589 C7.57409571%2C16.9294133 7.09354793%2C15.7697949 7.00729577%2C14.4703644 C6.94568708%2C13.4341097 7.27426676%2C12.5787883 7.99303481%2C11.9249609 C8.00535654%2C11.9167367 8.01357104%2C11.9085124 8.02178553%2C11.9002882 C8.24357681%2C11.7152427 8.44893911%2C11.5014124 8.66662315%2C11.2752456 C8.8226985%2C11.1148729 8.97877385%2C10.950388 9.15127818%2C10.7900153 C10.0261216%2C9.95114238 11.1761505%2C9.9552545 12.0222431%2C10.8023516 L14.0430082%2C12.8255156 C14.45784%2C13.2243915 14.6796313%2C13.7096218 14.6837385%2C14.2236371 C14.6878458%2C14.7499887 14.4701617%2C15.2475555 14.0471154%2C15.671104 L12.7902981%2C16.9294133 C12.4986837%2C17.2172619 12.0304576%2C17.2172619 11.7429504%2C16.9294133 C11.4554432%2C16.6374527 11.4554432%2C16.1686708 11.7429504%2C15.8808222 L12.9997677%2C14.6225129 C13.0901271%2C14.5279341 13.2010227%2C14.3840098 13.2010227%2C14.2359735 C13.1969155%2C14.0961613 13.0942343%2C13.9686855 13.0079822%2C13.8864431 C13.0038749%2C13.882331 12.9997677%2C13.8782188 12.9956604%2C13.8741067 L10.9707882%2C11.8468306 C10.6997099%2C11.5754306 10.4573824%2C11.5795427 10.1657679%2C11.859167 L10.1616607%2C11.8632791 C10.0137998%2C11.9989791 9.87415347%2C12.1429034 9.72629262%2C12.299164 C9.49628684%2C12.5376671 9.25395933%2C12.7885065 8.97877385%2C13.0187854 C8.60090721%2C13.3724278 8.44483187%2C13.7918643 8.48179708%2C14.3757856 C8.55162026%2C15.4243767 8.96645211%2C16.411286 9.31967526%2C17.15558 C10.3136288%2C19.2075289 11.7224142%2C21.0086383 13.5131734%2C22.5095628 C14.9958892%2C23.7431994 16.3677094%2C24.5697359 17.8381035%2C25.112536 C18.7211614%2C25.4415058 19.3988569%2C25.5648694 20.0354801%2C25.5114119 C20.4092395%2C25.4785149 20.7049612%2C25.3387027 20.9719322%2C25.0714148 L22.2246422%2C23.8172176 C22.5573291%2C23.4635751 22.388932%2C23.2168478 22.2328567%2C23.0605872 C22.2287494%2C23.056475 22.2205349%2C23.0523629 22.2164277%2C23.0441387 C22.0110654%2C22.8261962 21.7974886%2C22.6123659 21.5674828%2C22.3903113 C21.4524799%2C22.2751719 21.3292626%2C22.1559203 21.2101524%2C22.0366688 L20.2079844%2C21.033311 C20.1053033%2C20.930508 19.9574424%2C20.8112565 19.8095815%2C20.8112565 C19.6617207%2C20.8112565 19.5097526%2C20.9346201 19.4111787%2C21.033311 C19.3043903%2C21.1402262 19.1976019%2C21.2471414 19.0908135%2C21.3499444 C18.7786628%2C21.6583536 18.4829411%2C21.9462021 18.2036484%2C22.2628355 C18.1954339%2C22.2710598 18.1831121%2C22.2833961 18.1748976%2C22.2916204 C17.7148861%2C22.7480659 17.24666%2C22.5918053 17.0905847%2C22.5383477 C17.0741557%2C22.5342356 17.0577267%2C22.5301234 17.0412977%2C22.5218992 C16.3882456%2C22.2546113 15.776266%2C21.876296 15.0492834%2C21.300599 C15.0451762%2C21.300599 15.0451762%2C21.2964869 15.0410689%2C21.2964869 C14.3181936%2C20.7084534 13.6979995%2C20.1121957 13.1476285%2C19.4789289 C12.8765503%2C19.1705198 12.9094083%2C18.7017379 13.2174517%2C18.43445 C13.5254952%2C18.1630499 13.9937212%2C18.1959469 14.2606922%2C18.504356 C14.757669%2C19.0718289 15.3162544%2C19.6064047 15.9693065%2C20.1409806 C16.4703905%2C20.5357443 16.9016514%2C20.8194807 17.3246977%2C21.0250868 C17.562918%2C20.7701352 17.8093527%2C20.52752 18.047573%2C20.2931291 C18.1502542%2C20.190326 18.2570426%2C20.087523 18.3597237%2C19.9847199 C18.7868773%2C19.5570593 19.2838541%2C19.3308926 19.8013671%2C19.3308926 C20.3147728%2C19.3308926 20.8158568%2C19.5570593 21.2430104%2C19.9847199 L22.2451784%2C20.9880777 C22.3601813%2C21.1032171 22.4751842%2C21.2183565 22.5901871%2C21.3293838 C22.8201929%2C21.5514384 23.0543059%2C21.7817172 23.2802044%2C22.0243324 Z M22.9885899%2C16.9952073 C23.0584131%2C17.3981952 22.7873349%2C17.7806226 22.3848248%2C17.8505287 C22.3437523%2C17.8587529 22.3026799%2C17.862865 22.2616074%2C17.862865 C21.9083843%2C17.862865 21.5962336%2C17.6079135 21.5346249%2C17.2460467 C21.3333698%2C16.0535314 20.7665699%2C14.963819 19.9040482%2C14.1002734 C19.0415265%2C13.2367278 17.9531064%2C12.669255 16.762005%2C12.467761 C16.3594949%2C12.3978549 16.0884167%2C12.0154276 16.1582399%2C11.6124396 C16.228063%2C11.2094517 16.6100369%2C10.9380516 17.012547%2C11.0079577 C18.5116918%2C11.2629093 19.8752975%2C11.9701943 20.9472887%2C13.0475702 C22.0274944%2C14.1331704 22.7339407%2C15.4983949 22.9885899%2C16.9952073 Z M26.9890476%2C16.8142739 C27.0588707%2C17.2172619 26.7877925%2C17.5996892 26.3770679%2C17.6654832 C26.3359954%2C17.6737074 26.294923%2C17.6778195 26.2538505%2C17.6778195 C25.9006274%2C17.6778195 25.5884767%2C17.422868 25.526868%2C17.0610012 C25.1654303%2C14.9144736 24.1509406%2C12.9571035 22.5984016%2C11.4027214 C21.0458626%2C9.84833933 19.0908135%2C8.83675733 16.9468311%2C8.47077848 C16.544321%2C8.4008724 16.2732427%2C8.01844506 16.3430659%2C7.61545711 C16.4128891%2C7.21246916 16.794863%2C6.94106911 17.1973731%2C7.01097518 C19.6452917%2C7.4262995 21.8755263%2C8.58591789 23.6457493%2C10.3582425 C25.4159723%2C12.130567 26.5742157%2C14.3634492 26.9890476%2C16.8142739 Z'/%3E%3C/svg%3E\"); }\n\n[data-rz] .cms-supply-cta__phone-number {\n  display: inline-block;\n  text-align: center;\n  vertical-align: middle; }\n\n.cms-content {\n  margin-bottom: 20px; }\n\n@media screen and (min-width: 0) and (max-width: 744px) {\n  .rz-slider {\n    padding-top: 15px;\n    background-color: #ffffff; }\n  .rz-slider__arrow {\n    display: none; }\n  .rz-slider__item {\n    padding-bottom: 15px; } }\n\n@media screen and (min-width: 744px) {\n  .rz-slider {\n    position: relative; }\n  .rz-slider__arrow {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    cursor: pointer; }\n  .rz-slider__arrow--backwards {\n    left: 0; }\n  .rz-slider__arrow--forward {\n    right: 0; }\n  .rz-slider__item {\n    padding: 15px;\n    display: none; }\n  .rz-slider__item--active {\n    display: block; } }\n";

},{}],2:[function(require,module,exports){

/**
 * Expose `Emitter`.
 */

if (typeof module !== 'undefined') {
  module.exports = Emitter;
}

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }
  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};
  var args = [].slice.call(arguments, 1)
    , callbacks = this._callbacks['$' + event];

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};

},{}],3:[function(require,module,exports){
(function (process,global){
/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.2+97478eb6
 */

(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.ES6Promise = factory());
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  var type = typeof x;
  return x !== null && (type === 'object' || type === 'function');
}

function isFunction(x) {
  return typeof x === 'function';
}



var _isArray = void 0;
if (Array.isArray) {
  _isArray = Array.isArray;
} else {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
}

var isArray = _isArray;

var len = 0;
var vertxNext = void 0;
var customSchedulerFn = void 0;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  if (typeof vertxNext !== 'undefined') {
    return function () {
      vertxNext(flush);
    };
  }

  return useSetTimeout();
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var r = require;
    var vertx = r('vertx');
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = void 0;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && typeof require === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;


  if (_state) {
    var callback = arguments[_state - 1];
    asap(function () {
      return invokeCallback(_state, child, callback, parent._result);
    });
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve$1(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(16);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

var GET_THEN_ERROR = new ErrorObject();

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function getThen(promise) {
  try {
    return promise.then;
  } catch (error) {
    GET_THEN_ERROR.error = error;
    return GET_THEN_ERROR;
  }
}

function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
  try {
    then$$1.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then$$1) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then$$1, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return resolve(promise, value);
    }, function (reason) {
      return reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$1) {
  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$1 === GET_THEN_ERROR) {
      reject(promise, GET_THEN_ERROR.error);
      GET_THEN_ERROR.error = null;
    } else if (then$$1 === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$1)) {
      handleForeignThenable(promise, maybeThenable, then$$1);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function resolve(promise, value) {
  if (promise === value) {
    reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    handleMaybeThenable(promise, value, getThen(value));
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;


  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = void 0,
      callback = void 0,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function ErrorObject() {
  this.error = null;
}

var TRY_CATCH_ERROR = new ErrorObject();

function tryCatch(callback, detail) {
  try {
    return callback(detail);
  } catch (e) {
    TRY_CATCH_ERROR.error = e;
    return TRY_CATCH_ERROR;
  }
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = void 0,
      error = void 0,
      succeeded = void 0,
      failed = void 0;

  if (hasCallback) {
    value = tryCatch(callback, detail);

    if (value === TRY_CATCH_ERROR) {
      failed = true;
      error = value.error;
      value.error = null;
    } else {
      succeeded = true;
    }

    if (promise === value) {
      reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
    succeeded = true;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
    resolve(promise, value);
  } else if (failed) {
    reject(promise, error);
  } else if (settled === FULFILLED) {
    fulfill(promise, value);
  } else if (settled === REJECTED) {
    reject(promise, value);
  }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      resolve(promise, value);
    }, function rejectPromise(reason) {
      reject(promise, reason);
    });
  } catch (e) {
    reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
}

var Enumerator = function () {
  function Enumerator(Constructor, input) {
    this._instanceConstructor = Constructor;
    this.promise = new Constructor(noop);

    if (!this.promise[PROMISE_ID]) {
      makePromise(this.promise);
    }

    if (isArray(input)) {
      this.length = input.length;
      this._remaining = input.length;

      this._result = new Array(this.length);

      if (this.length === 0) {
        fulfill(this.promise, this._result);
      } else {
        this.length = this.length || 0;
        this._enumerate(input);
        if (this._remaining === 0) {
          fulfill(this.promise, this._result);
        }
      }
    } else {
      reject(this.promise, validationError());
    }
  }

  Enumerator.prototype._enumerate = function _enumerate(input) {
    for (var i = 0; this._state === PENDING && i < input.length; i++) {
      this._eachEntry(input[i], i);
    }
  };

  Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
    var c = this._instanceConstructor;
    var resolve$$1 = c.resolve;


    if (resolve$$1 === resolve$1) {
      var _then = getThen(entry);

      if (_then === then && entry._state !== PENDING) {
        this._settledAt(entry._state, i, entry._result);
      } else if (typeof _then !== 'function') {
        this._remaining--;
        this._result[i] = entry;
      } else if (c === Promise$1) {
        var promise = new c(noop);
        handleMaybeThenable(promise, entry, _then);
        this._willSettleAt(promise, i);
      } else {
        this._willSettleAt(new c(function (resolve$$1) {
          return resolve$$1(entry);
        }), i);
      }
    } else {
      this._willSettleAt(resolve$$1(entry), i);
    }
  };

  Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
    var promise = this.promise;


    if (promise._state === PENDING) {
      this._remaining--;

      if (state === REJECTED) {
        reject(promise, value);
      } else {
        this._result[i] = value;
      }
    }

    if (this._remaining === 0) {
      fulfill(promise, this._result);
    }
  };

  Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
    var enumerator = this;

    subscribe(promise, undefined, function (value) {
      return enumerator._settledAt(FULFILLED, i, value);
    }, function (reason) {
      return enumerator._settledAt(REJECTED, i, reason);
    });
  };

  return Enumerator;
}();

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all(entries) {
  return new Enumerator(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject$1(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {Function} resolver
  Useful for tooling.
  @constructor
*/

var Promise$1 = function () {
  function Promise(resolver) {
    this[PROMISE_ID] = nextId();
    this._result = this._state = undefined;
    this._subscribers = [];

    if (noop !== resolver) {
      typeof resolver !== 'function' && needsResolver();
      this instanceof Promise ? initializePromise(this, resolver) : needsNew();
    }
  }

  /**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.
   ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```
   Chaining
  --------
   The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.
   ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });
   findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we're unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
   ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```
   Assimilation
  ------------
   Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```
   If the assimliated promise rejects, then the downstream promise will also reject.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```
   Simple Example
  --------------
   Synchronous Example
   ```javascript
  let result;
   try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```
   Advanced Example
  --------------
   Synchronous Example
   ```javascript
  let author, books;
   try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
   function foundBooks(books) {
   }
   function failure(reason) {
   }
   findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```
   @method then
  @param {Function} onFulfilled
  @param {Function} onRejected
  Useful for tooling.
  @return {Promise}
  */

  /**
  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
  as the catch block of a try/catch statement.
  ```js
  function findAuthor(){
  throw new Error('couldn't find that author');
  }
  // synchronous
  try {
  findAuthor();
  } catch(reason) {
  // something went wrong
  }
  // async with promises
  findAuthor().catch(function(reason){
  // something went wrong
  });
  ```
  @method catch
  @param {Function} onRejection
  Useful for tooling.
  @return {Promise}
  */


  Promise.prototype.catch = function _catch(onRejection) {
    return this.then(null, onRejection);
  };

  /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves
  
    Synchronous example:
  
    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }
  
    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuther();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```
  
    Asynchronous example:
  
    ```js
    findAuthor().catch(function(reason){
      return findOtherAuther();
    }).finally(function(){
      // author was either found, or not
    });
    ```
  
    @method finally
    @param {Function} callback
    @return {Promise}
  */


  Promise.prototype.finally = function _finally(callback) {
    var promise = this;
    var constructor = promise.constructor;

    return promise.then(function (value) {
      return constructor.resolve(callback()).then(function () {
        return value;
      });
    }, function (reason) {
      return constructor.resolve(callback()).then(function () {
        throw reason;
      });
    });
  };

  return Promise;
}();

Promise$1.prototype.then = then;
Promise$1.all = all;
Promise$1.race = race;
Promise$1.resolve = resolve$1;
Promise$1.reject = reject$1;
Promise$1._setScheduler = setScheduler;
Promise$1._setAsap = setAsap;
Promise$1._asap = asap;

/*global self*/
function polyfill() {
    var local = void 0;

    if (typeof global !== 'undefined') {
        local = global;
    } else if (typeof self !== 'undefined') {
        local = self;
    } else {
        try {
            local = Function('return this')();
        } catch (e) {
            throw new Error('polyfill failed because global object is unavailable in this environment');
        }
    }

    var P = local.Promise;

    if (P) {
        var promiseToString = null;
        try {
            promiseToString = Object.prototype.toString.call(P.resolve());
        } catch (e) {
            // silently ignored
        }

        if (promiseToString === '[object Promise]' && !P.cast) {
            return;
        }
    }

    local.Promise = Promise$1;
}

// Strange compat..
Promise$1.polyfill = polyfill;
Promise$1.Promise = Promise$1;

return Promise$1;

})));





}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"_process":4}],4:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],5:[function(require,module,exports){
module.exports = require('./src/superagent-promise-plugin');

},{"./src/superagent-promise-plugin":6}],6:[function(require,module,exports){
function endPromise(req) {
  var _Promise = superagentPromisePlugin.Promise || Promise;

  return new _Promise(function (resolve, reject) {
    req.end(function (err, res) {
      err = err || res.error;
      if (err) {
        err.response = res;
        reject(err);
      } else 
        resolve(res);
    });
  });
}

function then() {
  var promise = endPromise(this);
  return promise.then.apply(promise, arguments);
}

function _catch() {
  var promise = endPromise(this);
  return promise.catch.apply(promise, arguments);
}

/**
 * Adds req.then and req.catch methods
 * @param {Object} req
 * @return {Object} req
 */
function superagentPromisePlugin(req) {
  req.then = then;
  req['catch'] = _catch;
  return req;
}

/**
 * Patches superagent so that every request has req.then and req.catch methods
 * @param {Object} superagent
 * @return {Object} superagent
 */
superagentPromisePlugin.patch = function patch(superagent) {
  superagent.Request.prototype.then = then;
  superagent.Request.prototype['catch'] = _catch;
  return superagent;
};

/**
 * Override with a Promise implementation
 */
superagentPromisePlugin.Promise = null;

module.exports = superagentPromisePlugin;

},{}],7:[function(require,module,exports){
function Agent() {
  this._defaults = [];
}

["use", "on", "once", "set", "query", "type", "accept", "auth", "withCredentials", "sortQuery", "retry", "ok", "redirects",
 "timeout", "buffer", "serialize", "parse", "ca", "key", "pfx", "cert"].forEach(function(fn) {
  /** Default setting for all requests from this agent */
  Agent.prototype[fn] = function(/*varargs*/) {
    this._defaults.push({fn:fn, arguments:arguments});
    return this;
  }
});

Agent.prototype._setDefaults = function(req) {
    this._defaults.forEach(function(def) {
      req[def.fn].apply(req, def.arguments);
    });
};

module.exports = Agent;

},{}],8:[function(require,module,exports){
/**
 * Root reference for iframes.
 */

var root;
if (typeof window !== 'undefined') { // Browser window
  root = window;
} else if (typeof self !== 'undefined') { // Web Worker
  root = self;
} else { // Other environments
  console.warn("Using browser-only version of superagent in non-browser environment");
  root = this;
}

var Emitter = require('component-emitter');
var RequestBase = require('./request-base');
var isObject = require('./is-object');
var ResponseBase = require('./response-base');
var Agent = require('./agent-base');

/**
 * Noop.
 */

function noop(){};

/**
 * Expose `request`.
 */

var request = exports = module.exports = function(method, url) {
  // callback
  if ('function' == typeof url) {
    return new exports.Request('GET', method).end(url);
  }

  // url first
  if (1 == arguments.length) {
    return new exports.Request('GET', method);
  }

  return new exports.Request(method, url);
}

exports.Request = Request;

/**
 * Determine XHR.
 */

request.getXHR = function () {
  if (root.XMLHttpRequest
      && (!root.location || 'file:' != root.location.protocol
          || !root.ActiveXObject)) {
    return new XMLHttpRequest;
  } else {
    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
  }
  throw Error("Browser-only version of superagent could not find XHR");
};

/**
 * Removes leading and trailing whitespace, added to support IE.
 *
 * @param {String} s
 * @return {String}
 * @api private
 */

var trim = ''.trim
  ? function(s) { return s.trim(); }
  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };

/**
 * Serialize the given `obj`.
 *
 * @param {Object} obj
 * @return {String}
 * @api private
 */

function serialize(obj) {
  if (!isObject(obj)) return obj;
  var pairs = [];
  for (var key in obj) {
    pushEncodedKeyValuePair(pairs, key, obj[key]);
  }
  return pairs.join('&');
}

/**
 * Helps 'serialize' with serializing arrays.
 * Mutates the pairs array.
 *
 * @param {Array} pairs
 * @param {String} key
 * @param {Mixed} val
 */

function pushEncodedKeyValuePair(pairs, key, val) {
  if (val != null) {
    if (Array.isArray(val)) {
      val.forEach(function(v) {
        pushEncodedKeyValuePair(pairs, key, v);
      });
    } else if (isObject(val)) {
      for(var subkey in val) {
        pushEncodedKeyValuePair(pairs, key + '[' + subkey + ']', val[subkey]);
      }
    } else {
      pairs.push(encodeURIComponent(key)
        + '=' + encodeURIComponent(val));
    }
  } else if (val === null) {
    pairs.push(encodeURIComponent(key));
  }
}

/**
 * Expose serialization method.
 */

request.serializeObject = serialize;

/**
  * Parse the given x-www-form-urlencoded `str`.
  *
  * @param {String} str
  * @return {Object}
  * @api private
  */

function parseString(str) {
  var obj = {};
  var pairs = str.split('&');
  var pair;
  var pos;

  for (var i = 0, len = pairs.length; i < len; ++i) {
    pair = pairs[i];
    pos = pair.indexOf('=');
    if (pos == -1) {
      obj[decodeURIComponent(pair)] = '';
    } else {
      obj[decodeURIComponent(pair.slice(0, pos))] =
        decodeURIComponent(pair.slice(pos + 1));
    }
  }

  return obj;
}

/**
 * Expose parser.
 */

request.parseString = parseString;

/**
 * Default MIME type map.
 *
 *     superagent.types.xml = 'application/xml';
 *
 */

request.types = {
  html: 'text/html',
  json: 'application/json',
  xml: 'text/xml',
  urlencoded: 'application/x-www-form-urlencoded',
  'form': 'application/x-www-form-urlencoded',
  'form-data': 'application/x-www-form-urlencoded'
};

/**
 * Default serialization map.
 *
 *     superagent.serialize['application/xml'] = function(obj){
 *       return 'generated xml here';
 *     };
 *
 */

request.serialize = {
  'application/x-www-form-urlencoded': serialize,
  'application/json': JSON.stringify,
};

/**
  * Default parsers.
  *
  *     superagent.parse['application/xml'] = function(str){
  *       return { object parsed from str };
  *     };
  *
  */

request.parse = {
  'application/x-www-form-urlencoded': parseString,
  'application/json': JSON.parse,
};

/**
 * Parse the given header `str` into
 * an object containing the mapped fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

function parseHeader(str) {
  var lines = str.split(/\r?\n/);
  var fields = {};
  var index;
  var line;
  var field;
  var val;

  for (var i = 0, len = lines.length; i < len; ++i) {
    line = lines[i];
    index = line.indexOf(':');
    if (index === -1) { // could be empty line, just skip it
      continue;
    }
    field = line.slice(0, index).toLowerCase();
    val = trim(line.slice(index + 1));
    fields[field] = val;
  }

  return fields;
}

/**
 * Check if `mime` is json or has +json structured syntax suffix.
 *
 * @param {String} mime
 * @return {Boolean}
 * @api private
 */

function isJSON(mime) {
  // should match /json or +json
  // but not /json-seq
  return /[\/+]json($|[^-\w])/.test(mime);
}

/**
 * Initialize a new `Response` with the given `xhr`.
 *
 *  - set flags (.ok, .error, etc)
 *  - parse header
 *
 * Examples:
 *
 *  Aliasing `superagent` as `request` is nice:
 *
 *      request = superagent;
 *
 *  We can use the promise-like API, or pass callbacks:
 *
 *      request.get('/').end(function(res){});
 *      request.get('/', function(res){});
 *
 *  Sending data can be chained:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' })
 *        .end(function(res){});
 *
 *  Or passed to `.send()`:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' }, function(res){});
 *
 *  Or passed to `.post()`:
 *
 *      request
 *        .post('/user', { name: 'tj' })
 *        .end(function(res){});
 *
 * Or further reduced to a single call for simple cases:
 *
 *      request
 *        .post('/user', { name: 'tj' }, function(res){});
 *
 * @param {XMLHTTPRequest} xhr
 * @param {Object} options
 * @api private
 */

function Response(req) {
  this.req = req;
  this.xhr = this.req.xhr;
  // responseText is accessible only if responseType is '' or 'text' and on older browsers
  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
     ? this.xhr.responseText
     : null;
  this.statusText = this.req.xhr.statusText;
  var status = this.xhr.status;
  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
  if (status === 1223) {
    status = 204;
  }
  this._setStatusProperties(status);
  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
  // getResponseHeader still works. so we get content-type even if getting
  // other headers fails.
  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
  this._setHeaderProperties(this.header);

  if (null === this.text && req._responseType) {
    this.body = this.xhr.response;
  } else {
    this.body = this.req.method != 'HEAD'
      ? this._parseBody(this.text ? this.text : this.xhr.response)
      : null;
  }
}

ResponseBase(Response.prototype);

/**
 * Parse the given body `str`.
 *
 * Used for auto-parsing of bodies. Parsers
 * are defined on the `superagent.parse` object.
 *
 * @param {String} str
 * @return {Mixed}
 * @api private
 */

Response.prototype._parseBody = function(str) {
  var parse = request.parse[this.type];
  if (this.req._parser) {
    return this.req._parser(this, str);
  }
  if (!parse && isJSON(this.type)) {
    parse = request.parse['application/json'];
  }
  return parse && str && (str.length || str instanceof Object)
    ? parse(str)
    : null;
};

/**
 * Return an `Error` representative of this response.
 *
 * @return {Error}
 * @api public
 */

Response.prototype.toError = function(){
  var req = this.req;
  var method = req.method;
  var url = req.url;

  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
  var err = new Error(msg);
  err.status = this.status;
  err.method = method;
  err.url = url;

  return err;
};

/**
 * Expose `Response`.
 */

request.Response = Response;

/**
 * Initialize a new `Request` with the given `method` and `url`.
 *
 * @param {String} method
 * @param {String} url
 * @api public
 */

function Request(method, url) {
  var self = this;
  this._query = this._query || [];
  this.method = method;
  this.url = url;
  this.header = {}; // preserves header name case
  this._header = {}; // coerces header names to lowercase
  this.on('end', function(){
    var err = null;
    var res = null;

    try {
      res = new Response(self);
    } catch(e) {
      err = new Error('Parser is unable to parse the response');
      err.parse = true;
      err.original = e;
      // issue #675: return the raw response if the response parsing fails
      if (self.xhr) {
        // ie9 doesn't have 'response' property
        err.rawResponse = typeof self.xhr.responseType == 'undefined' ? self.xhr.responseText : self.xhr.response;
        // issue #876: return the http status code if the response parsing fails
        err.status = self.xhr.status ? self.xhr.status : null;
        err.statusCode = err.status; // backwards-compat only
      } else {
        err.rawResponse = null;
        err.status = null;
      }

      return self.callback(err);
    }

    self.emit('response', res);

    var new_err;
    try {
      if (!self._isResponseOK(res)) {
        new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
      }
    } catch(custom_err) {
      new_err = custom_err; // ok() callback can throw
    }

    // #1000 don't catch errors from the callback to avoid double calling it
    if (new_err) {
      new_err.original = err;
      new_err.response = res;
      new_err.status = res.status;
      self.callback(new_err, res);
    } else {
      self.callback(null, res);
    }
  });
}

/**
 * Mixin `Emitter` and `RequestBase`.
 */

Emitter(Request.prototype);
RequestBase(Request.prototype);

/**
 * Set Content-Type to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.xml = 'application/xml';
 *
 *      request.post('/')
 *        .type('xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 *      request.post('/')
 *        .type('application/xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 * @param {String} type
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.type = function(type){
  this.set('Content-Type', request.types[type] || type);
  return this;
};

/**
 * Set Accept to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.json = 'application/json';
 *
 *      request.get('/agent')
 *        .accept('json')
 *        .end(callback);
 *
 *      request.get('/agent')
 *        .accept('application/json')
 *        .end(callback);
 *
 * @param {String} accept
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.accept = function(type){
  this.set('Accept', request.types[type] || type);
  return this;
};

/**
 * Set Authorization field value with `user` and `pass`.
 *
 * @param {String} user
 * @param {String} [pass] optional in case of using 'bearer' as type
 * @param {Object} options with 'type' property 'auto', 'basic' or 'bearer' (default 'basic')
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.auth = function(user, pass, options){
  if (1 === arguments.length) pass = '';
  if (typeof pass === 'object' && pass !== null) { // pass is optional and can be replaced with options
    options = pass;
    pass = '';
  }
  if (!options) {
    options = {
      type: 'function' === typeof btoa ? 'basic' : 'auto',
    };
  }

  var encoder = function(string) {
    if ('function' === typeof btoa) {
      return btoa(string);
    }
    throw new Error('Cannot use basic auth, btoa is not a function');
  };

  return this._auth(user, pass, options, encoder);
};

/**
 * Add query-string `val`.
 *
 * Examples:
 *
 *   request.get('/shoes')
 *     .query('size=10')
 *     .query({ color: 'blue' })
 *
 * @param {Object|String} val
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.query = function(val){
  if ('string' != typeof val) val = serialize(val);
  if (val) this._query.push(val);
  return this;
};

/**
 * Queue the given `file` as an attachment to the specified `field`,
 * with optional `options` (or filename).
 *
 * ``` js
 * request.post('/upload')
 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
 *   .end(callback);
 * ```
 *
 * @param {String} field
 * @param {Blob|File} file
 * @param {String|Object} options
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.attach = function(field, file, options){
  if (file) {
    if (this._data) {
      throw Error("superagent can't mix .send() and .attach()");
    }

    this._getFormData().append(field, file, options || file.name);
  }
  return this;
};

Request.prototype._getFormData = function(){
  if (!this._formData) {
    this._formData = new root.FormData();
  }
  return this._formData;
};

/**
 * Invoke the callback with `err` and `res`
 * and handle arity check.
 *
 * @param {Error} err
 * @param {Response} res
 * @api private
 */

Request.prototype.callback = function(err, res){
  if (this._shouldRetry(err, res)) {
    return this._retry();
  }

  var fn = this._callback;
  this.clearTimeout();

  if (err) {
    if (this._maxRetries) err.retries = this._retries - 1;
    this.emit('error', err);
  }

  fn(err, res);
};

/**
 * Invoke callback with x-domain error.
 *
 * @api private
 */

Request.prototype.crossDomainError = function(){
  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
  err.crossDomain = true;

  err.status = this.status;
  err.method = this.method;
  err.url = this.url;

  this.callback(err);
};

// This only warns, because the request is still likely to work
Request.prototype.buffer = Request.prototype.ca = Request.prototype.agent = function(){
  console.warn("This is not supported in browser version of superagent");
  return this;
};

// This throws, because it can't send/receive data as expected
Request.prototype.pipe = Request.prototype.write = function(){
  throw Error("Streaming is not supported in browser version of superagent");
};

/**
 * Check if `obj` is a host object,
 * we don't want to serialize these :)
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */
Request.prototype._isHost = function _isHost(obj) {
  // Native objects stringify to [object File], [object Blob], [object FormData], etc.
  return obj && 'object' === typeof obj && !Array.isArray(obj) && Object.prototype.toString.call(obj) !== '[object Object]';
}

/**
 * Initiate request, invoking callback `fn(res)`
 * with an instanceof `Response`.
 *
 * @param {Function} fn
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.end = function(fn){
  if (this._endCalled) {
    console.warn("Warning: .end() was called twice. This is not supported in superagent");
  }
  this._endCalled = true;

  // store callback
  this._callback = fn || noop;

  // querystring
  this._finalizeQueryString();

  return this._end();
};

Request.prototype._end = function() {
  var self = this;
  var xhr = (this.xhr = request.getXHR());
  var data = this._formData || this._data;

  this._setTimeouts();

  // state change
  xhr.onreadystatechange = function(){
    var readyState = xhr.readyState;
    if (readyState >= 2 && self._responseTimeoutTimer) {
      clearTimeout(self._responseTimeoutTimer);
    }
    if (4 != readyState) {
      return;
    }

    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
    // result in the error "Could not complete the operation due to error c00c023f"
    var status;
    try { status = xhr.status } catch(e) { status = 0; }

    if (!status) {
      if (self.timedout || self._aborted) return;
      return self.crossDomainError();
    }
    self.emit('end');
  };

  // progress
  var handleProgress = function(direction, e) {
    if (e.total > 0) {
      e.percent = e.loaded / e.total * 100;
    }
    e.direction = direction;
    self.emit('progress', e);
  };
  if (this.hasListeners('progress')) {
    try {
      xhr.onprogress = handleProgress.bind(null, 'download');
      if (xhr.upload) {
        xhr.upload.onprogress = handleProgress.bind(null, 'upload');
      }
    } catch(e) {
      // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
      // Reported here:
      // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
    }
  }

  // initiate request
  try {
    if (this.username && this.password) {
      xhr.open(this.method, this.url, true, this.username, this.password);
    } else {
      xhr.open(this.method, this.url, true);
    }
  } catch (err) {
    // see #1149
    return this.callback(err);
  }

  // CORS
  if (this._withCredentials) xhr.withCredentials = true;

  // body
  if (!this._formData && 'GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !this._isHost(data)) {
    // serialize stuff
    var contentType = this._header['content-type'];
    var serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
    if (!serialize && isJSON(contentType)) {
      serialize = request.serialize['application/json'];
    }
    if (serialize) data = serialize(data);
  }

  // set header fields
  for (var field in this.header) {
    if (null == this.header[field]) continue;

    if (this.header.hasOwnProperty(field))
      xhr.setRequestHeader(field, this.header[field]);
  }

  if (this._responseType) {
    xhr.responseType = this._responseType;
  }

  // send stuff
  this.emit('request', this);

  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
  // We need null here if data is undefined
  xhr.send(typeof data !== 'undefined' ? data : null);
  return this;
};

request.agent = function() {
  return new Agent();
};

["GET", "POST", "OPTIONS", "PATCH", "PUT", "DELETE"].forEach(function(method) {
  Agent.prototype[method.toLowerCase()] = function(url, fn) {
    var req = new request.Request(method, url);
    this._setDefaults(req);
    if (fn) {
      req.end(fn);
    }
    return req;
  };
});

Agent.prototype.del = Agent.prototype['delete'];

/**
 * GET `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.get = function(url, data, fn) {
  var req = request('GET', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * HEAD `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.head = function(url, data, fn) {
  var req = request('HEAD', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * OPTIONS query to `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.options = function(url, data, fn) {
  var req = request('OPTIONS', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * DELETE `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

function del(url, data, fn) {
  var req = request('DELETE', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
}

request['del'] = del;
request['delete'] = del;

/**
 * PATCH `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.patch = function(url, data, fn) {
  var req = request('PATCH', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * POST `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.post = function(url, data, fn) {
  var req = request('POST', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * PUT `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.put = function(url, data, fn) {
  var req = request('PUT', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

},{"./agent-base":7,"./is-object":9,"./request-base":10,"./response-base":11,"component-emitter":2}],9:[function(require,module,exports){
'use strict';

/**
 * Check if `obj` is an object.
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */

function isObject(obj) {
  return null !== obj && 'object' === typeof obj;
}

module.exports = isObject;

},{}],10:[function(require,module,exports){
'use strict';

/**
 * Module of mixed-in functions shared between node and client code
 */
var isObject = require('./is-object');

/**
 * Expose `RequestBase`.
 */

module.exports = RequestBase;

/**
 * Initialize a new `RequestBase`.
 *
 * @api public
 */

function RequestBase(obj) {
  if (obj) return mixin(obj);
}

/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in RequestBase.prototype) {
    obj[key] = RequestBase.prototype[key];
  }
  return obj;
}

/**
 * Clear previous timeout.
 *
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.clearTimeout = function _clearTimeout(){
  clearTimeout(this._timer);
  clearTimeout(this._responseTimeoutTimer);
  delete this._timer;
  delete this._responseTimeoutTimer;
  return this;
};

/**
 * Override default response body parser
 *
 * This function will be called to convert incoming data into request.body
 *
 * @param {Function}
 * @api public
 */

RequestBase.prototype.parse = function parse(fn){
  this._parser = fn;
  return this;
};

/**
 * Set format of binary response body.
 * In browser valid formats are 'blob' and 'arraybuffer',
 * which return Blob and ArrayBuffer, respectively.
 *
 * In Node all values result in Buffer.
 *
 * Examples:
 *
 *      req.get('/')
 *        .responseType('blob')
 *        .end(callback);
 *
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.responseType = function(val){
  this._responseType = val;
  return this;
};

/**
 * Override default request body serializer
 *
 * This function will be called to convert data set via .send or .attach into payload to send
 *
 * @param {Function}
 * @api public
 */

RequestBase.prototype.serialize = function serialize(fn){
  this._serializer = fn;
  return this;
};

/**
 * Set timeouts.
 *
 * - response timeout is time between sending request and receiving the first byte of the response. Includes DNS and connection time.
 * - deadline is the time from start of the request to receiving response body in full. If the deadline is too short large files may not load at all on slow connections.
 *
 * Value of 0 or false means no timeout.
 *
 * @param {Number|Object} ms or {response, deadline}
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.timeout = function timeout(options){
  if (!options || 'object' !== typeof options) {
    this._timeout = options;
    this._responseTimeout = 0;
    return this;
  }

  for(var option in options) {
    switch(option) {
      case 'deadline':
        this._timeout = options.deadline;
        break;
      case 'response':
        this._responseTimeout = options.response;
        break;
      default:
        console.warn("Unknown timeout option", option);
    }
  }
  return this;
};

/**
 * Set number of retry attempts on error.
 *
 * Failed requests will be retried 'count' times if timeout or err.code >= 500.
 *
 * @param {Number} count
 * @param {Function} [fn]
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.retry = function retry(count, fn){
  // Default to 1 if no count passed or true
  if (arguments.length === 0 || count === true) count = 1;
  if (count <= 0) count = 0;
  this._maxRetries = count;
  this._retries = 0;
  this._retryCallback = fn;
  return this;
};

var ERROR_CODES = [
  'ECONNRESET',
  'ETIMEDOUT',
  'EADDRINFO',
  'ESOCKETTIMEDOUT'
];

/**
 * Determine if a request should be retried.
 * (Borrowed from segmentio/superagent-retry)
 *
 * @param {Error} err
 * @param {Response} [res]
 * @returns {Boolean}
 */
RequestBase.prototype._shouldRetry = function(err, res) {
  if (!this._maxRetries || this._retries++ >= this._maxRetries) {
    return false;
  }
  if (this._retryCallback) {
    try {
      var override = this._retryCallback(err, res);
      if (override === true) return true;
      if (override === false) return false;
      // undefined falls back to defaults
    } catch(e) {
      console.error(e);
    }
  }
  if (res && res.status && res.status >= 500 && res.status != 501) return true;
  if (err) {
    if (err.code && ~ERROR_CODES.indexOf(err.code)) return true;
    // Superagent timeout
    if (err.timeout && err.code == 'ECONNABORTED') return true;
    if (err.crossDomain) return true;
  }
  return false;
};

/**
 * Retry request
 *
 * @return {Request} for chaining
 * @api private
 */

RequestBase.prototype._retry = function() {

  this.clearTimeout();

  // node
  if (this.req) {
    this.req = null;
    this.req = this.request();
  }

  this._aborted = false;
  this.timedout = false;

  return this._end();
};

/**
 * Promise support
 *
 * @param {Function} resolve
 * @param {Function} [reject]
 * @return {Request}
 */

RequestBase.prototype.then = function then(resolve, reject) {
  if (!this._fullfilledPromise) {
    var self = this;
    if (this._endCalled) {
      console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises");
    }
    this._fullfilledPromise = new Promise(function(innerResolve, innerReject) {
      self.end(function(err, res) {
        if (err) innerReject(err);
        else innerResolve(res);
      });
    });
  }
  return this._fullfilledPromise.then(resolve, reject);
};

RequestBase.prototype.catch = function(cb) {
  return this.then(undefined, cb);
};

/**
 * Allow for extension
 */

RequestBase.prototype.use = function use(fn) {
  fn(this);
  return this;
};

RequestBase.prototype.ok = function(cb) {
  if ('function' !== typeof cb) throw Error("Callback required");
  this._okCallback = cb;
  return this;
};

RequestBase.prototype._isResponseOK = function(res) {
  if (!res) {
    return false;
  }

  if (this._okCallback) {
    return this._okCallback(res);
  }

  return res.status >= 200 && res.status < 300;
};

/**
 * Get request header `field`.
 * Case-insensitive.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

RequestBase.prototype.get = function(field){
  return this._header[field.toLowerCase()];
};

/**
 * Get case-insensitive header `field` value.
 * This is a deprecated internal API. Use `.get(field)` instead.
 *
 * (getHeader is no longer used internally by the superagent code base)
 *
 * @param {String} field
 * @return {String}
 * @api private
 * @deprecated
 */

RequestBase.prototype.getHeader = RequestBase.prototype.get;

/**
 * Set header `field` to `val`, or multiple fields with one object.
 * Case-insensitive.
 *
 * Examples:
 *
 *      req.get('/')
 *        .set('Accept', 'application/json')
 *        .set('X-API-Key', 'foobar')
 *        .end(callback);
 *
 *      req.get('/')
 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
 *        .end(callback);
 *
 * @param {String|Object} field
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.set = function(field, val){
  if (isObject(field)) {
    for (var key in field) {
      this.set(key, field[key]);
    }
    return this;
  }
  this._header[field.toLowerCase()] = val;
  this.header[field] = val;
  return this;
};

/**
 * Remove header `field`.
 * Case-insensitive.
 *
 * Example:
 *
 *      req.get('/')
 *        .unset('User-Agent')
 *        .end(callback);
 *
 * @param {String} field
 */
RequestBase.prototype.unset = function(field){
  delete this._header[field.toLowerCase()];
  delete this.header[field];
  return this;
};

/**
 * Write the field `name` and `val`, or multiple fields with one object
 * for "multipart/form-data" request bodies.
 *
 * ``` js
 * request.post('/upload')
 *   .field('foo', 'bar')
 *   .end(callback);
 *
 * request.post('/upload')
 *   .field({ foo: 'bar', baz: 'qux' })
 *   .end(callback);
 * ```
 *
 * @param {String|Object} name
 * @param {String|Blob|File|Buffer|fs.ReadStream} val
 * @return {Request} for chaining
 * @api public
 */
RequestBase.prototype.field = function(name, val) {
  // name should be either a string or an object.
  if (null === name || undefined === name) {
    throw new Error('.field(name, val) name can not be empty');
  }

  if (this._data) {
    console.error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObject(name)) {
    for (var key in name) {
      this.field(key, name[key]);
    }
    return this;
  }

  if (Array.isArray(val)) {
    for (var i in val) {
      this.field(name, val[i]);
    }
    return this;
  }

  // val should be defined now
  if (null === val || undefined === val) {
    throw new Error('.field(name, val) val can not be empty');
  }
  if ('boolean' === typeof val) {
    val = '' + val;
  }
  this._getFormData().append(name, val);
  return this;
};

/**
 * Abort the request, and clear potential timeout.
 *
 * @return {Request}
 * @api public
 */
RequestBase.prototype.abort = function(){
  if (this._aborted) {
    return this;
  }
  this._aborted = true;
  this.xhr && this.xhr.abort(); // browser
  this.req && this.req.abort(); // node
  this.clearTimeout();
  this.emit('abort');
  return this;
};

RequestBase.prototype._auth = function(user, pass, options, base64Encoder) {
  switch (options.type) {
    case 'basic':
      this.set('Authorization', 'Basic ' + base64Encoder(user + ':' + pass));
      break;

    case 'auto':
      this.username = user;
      this.password = pass;
      break;

    case 'bearer': // usage would be .auth(accessToken, { type: 'bearer' })
      this.set('Authorization', 'Bearer ' + user);
      break;
  }
  return this;
};

/**
 * Enable transmission of cookies with x-domain requests.
 *
 * Note that for this to work the origin must not be
 * using "Access-Control-Allow-Origin" with a wildcard,
 * and also must set "Access-Control-Allow-Credentials"
 * to "true".
 *
 * @api public
 */

RequestBase.prototype.withCredentials = function(on) {
  // This is browser-only functionality. Node side is no-op.
  if (on == undefined) on = true;
  this._withCredentials = on;
  return this;
};

/**
 * Set the max redirects to `n`. Does noting in browser XHR implementation.
 *
 * @param {Number} n
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.redirects = function(n){
  this._maxRedirects = n;
  return this;
};

/**
 * Maximum size of buffered response body, in bytes. Counts uncompressed size.
 * Default 200MB.
 *
 * @param {Number} n
 * @return {Request} for chaining
 */
RequestBase.prototype.maxResponseSize = function(n){
  if ('number' !== typeof n) {
    throw TypeError("Invalid argument");
  }
  this._maxResponseSize = n;
  return this;
};

/**
 * Convert to a plain javascript object (not JSON string) of scalar properties.
 * Note as this method is designed to return a useful non-this value,
 * it cannot be chained.
 *
 * @return {Object} describing method, url, and data of this request
 * @api public
 */

RequestBase.prototype.toJSON = function() {
  return {
    method: this.method,
    url: this.url,
    data: this._data,
    headers: this._header,
  };
};

/**
 * Send `data` as the request body, defaulting the `.type()` to "json" when
 * an object is given.
 *
 * Examples:
 *
 *       // manual json
 *       request.post('/user')
 *         .type('json')
 *         .send('{"name":"tj"}')
 *         .end(callback)
 *
 *       // auto json
 *       request.post('/user')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // manual x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send('name=tj')
 *         .end(callback)
 *
 *       // auto x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // defaults to x-www-form-urlencoded
 *      request.post('/user')
 *        .send('name=tobi')
 *        .send('species=ferret')
 *        .end(callback)
 *
 * @param {String|Object} data
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.send = function(data){
  var isObj = isObject(data);
  var type = this._header['content-type'];

  if (this._formData) {
    console.error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObj && !this._data) {
    if (Array.isArray(data)) {
      this._data = [];
    } else if (!this._isHost(data)) {
      this._data = {};
    }
  } else if (data && this._data && this._isHost(this._data)) {
    throw Error("Can't merge these send calls");
  }

  // merge
  if (isObj && isObject(this._data)) {
    for (var key in data) {
      this._data[key] = data[key];
    }
  } else if ('string' == typeof data) {
    // default to x-www-form-urlencoded
    if (!type) this.type('form');
    type = this._header['content-type'];
    if ('application/x-www-form-urlencoded' == type) {
      this._data = this._data
        ? this._data + '&' + data
        : data;
    } else {
      this._data = (this._data || '') + data;
    }
  } else {
    this._data = data;
  }

  if (!isObj || this._isHost(data)) {
    return this;
  }

  // default to json
  if (!type) this.type('json');
  return this;
};

/**
 * Sort `querystring` by the sort function
 *
 *
 * Examples:
 *
 *       // default order
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery()
 *         .end(callback)
 *
 *       // customized sort function
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery(function(a, b){
 *           return a.length - b.length;
 *         })
 *         .end(callback)
 *
 *
 * @param {Function} sort
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.sortQuery = function(sort) {
  // _sort default to true but otherwise can be a function or boolean
  this._sort = typeof sort === 'undefined' ? true : sort;
  return this;
};

/**
 * Compose querystring to append to req.url
 *
 * @api private
 */
RequestBase.prototype._finalizeQueryString = function(){
  var query = this._query.join('&');
  if (query) {
    this.url += (this.url.indexOf('?') >= 0 ? '&' : '?') + query;
  }
  this._query.length = 0; // Makes the call idempotent

  if (this._sort) {
    var index = this.url.indexOf('?');
    if (index >= 0) {
      var queryArr = this.url.substring(index + 1).split('&');
      if ('function' === typeof this._sort) {
        queryArr.sort(this._sort);
      } else {
        queryArr.sort();
      }
      this.url = this.url.substring(0, index) + '?' + queryArr.join('&');
    }
  }
};

// For backwards compat only
RequestBase.prototype._appendQueryString = function() {console.trace("Unsupported");}

/**
 * Invoke callback with timeout error.
 *
 * @api private
 */

RequestBase.prototype._timeoutError = function(reason, timeout, errno){
  if (this._aborted) {
    return;
  }
  var err = new Error(reason + timeout + 'ms exceeded');
  err.timeout = timeout;
  err.code = 'ECONNABORTED';
  err.errno = errno;
  this.timedout = true;
  this.abort();
  this.callback(err);
};

RequestBase.prototype._setTimeouts = function() {
  var self = this;

  // deadline
  if (this._timeout && !this._timer) {
    this._timer = setTimeout(function(){
      self._timeoutError('Timeout of ', self._timeout, 'ETIME');
    }, this._timeout);
  }
  // response timeout
  if (this._responseTimeout && !this._responseTimeoutTimer) {
    this._responseTimeoutTimer = setTimeout(function(){
      self._timeoutError('Response timeout of ', self._responseTimeout, 'ETIMEDOUT');
    }, this._responseTimeout);
  }
};

},{"./is-object":9}],11:[function(require,module,exports){
'use strict';

/**
 * Module dependencies.
 */

var utils = require('./utils');

/**
 * Expose `ResponseBase`.
 */

module.exports = ResponseBase;

/**
 * Initialize a new `ResponseBase`.
 *
 * @api public
 */

function ResponseBase(obj) {
  if (obj) return mixin(obj);
}

/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in ResponseBase.prototype) {
    obj[key] = ResponseBase.prototype[key];
  }
  return obj;
}

/**
 * Get case-insensitive `field` value.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

ResponseBase.prototype.get = function(field) {
  return this.header[field.toLowerCase()];
};

/**
 * Set header related properties:
 *
 *   - `.type` the content type without params
 *
 * A response of "Content-Type: text/plain; charset=utf-8"
 * will provide you with a `.type` of "text/plain".
 *
 * @param {Object} header
 * @api private
 */

ResponseBase.prototype._setHeaderProperties = function(header){
    // TODO: moar!
    // TODO: make this a util

    // content-type
    var ct = header['content-type'] || '';
    this.type = utils.type(ct);

    // params
    var params = utils.params(ct);
    for (var key in params) this[key] = params[key];

    this.links = {};

    // links
    try {
        if (header.link) {
            this.links = utils.parseLinks(header.link);
        }
    } catch (err) {
        // ignore
    }
};

/**
 * Set flags such as `.ok` based on `status`.
 *
 * For example a 2xx response will give you a `.ok` of __true__
 * whereas 5xx will be __false__ and `.error` will be __true__. The
 * `.clientError` and `.serverError` are also available to be more
 * specific, and `.statusType` is the class of error ranging from 1..5
 * sometimes useful for mapping respond colors etc.
 *
 * "sugar" properties are also defined for common cases. Currently providing:
 *
 *   - .noContent
 *   - .badRequest
 *   - .unauthorized
 *   - .notAcceptable
 *   - .notFound
 *
 * @param {Number} status
 * @api private
 */

ResponseBase.prototype._setStatusProperties = function(status){
    var type = status / 100 | 0;

    // status / class
    this.status = this.statusCode = status;
    this.statusType = type;

    // basics
    this.info = 1 == type;
    this.ok = 2 == type;
    this.redirect = 3 == type;
    this.clientError = 4 == type;
    this.serverError = 5 == type;
    this.error = (4 == type || 5 == type)
        ? this.toError()
        : false;

    // sugar
    this.accepted = 202 == status;
    this.noContent = 204 == status;
    this.badRequest = 400 == status;
    this.unauthorized = 401 == status;
    this.notAcceptable = 406 == status;
    this.forbidden = 403 == status;
    this.notFound = 404 == status;
};

},{"./utils":12}],12:[function(require,module,exports){
'use strict';

/**
 * Return the mime type for the given `str`.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

exports.type = function(str){
  return str.split(/ *; */).shift();
};

/**
 * Return header field parameters.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

exports.params = function(str){
  return str.split(/ *; */).reduce(function(obj, str){
    var parts = str.split(/ *= */);
    var key = parts.shift();
    var val = parts.shift();

    if (key && val) obj[key] = val;
    return obj;
  }, {});
};

/**
 * Parse Link header fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

exports.parseLinks = function(str){
  return str.split(/ *, */).reduce(function(obj, str){
    var parts = str.split(/ *; */);
    var url = parts[0].slice(1, -1);
    var rel = parts[1].split(/ *= */)[1].slice(1, -1);
    obj[rel] = url;
    return obj;
  }, {});
};

/**
 * Strip content related fields from `header`.
 *
 * @param {Object} header
 * @return {Object} header
 * @api private
 */

exports.cleanHeader = function(header, changesOrigin){
  delete header['content-type'];
  delete header['content-length'];
  delete header['transfer-encoding'];
  delete header['host'];
  // secuirty
  if (changesOrigin) {
    delete header['authorization'];
    delete header['cookie'];
  }
  return header;
};

},{}],13:[function(require,module,exports){
'use strict';

var shorten = function shorten(text, limit) {
  if (text && text.length > limit) {
    return text.substr(0, text.lastIndexOf(' ', limit)) + '...';
  }
  return text || '';
};

module.exports = { shorten: shorten };

},{}],14:[function(require,module,exports){
'use strict';

var onClose = function onClose() {};

var _initModal = function _initModal(opts) {
  if (opts.onClose) {
    onClose = opts.onClose;
  }

  var modal = document.getElementById(opts.id);
  var span = document.getElementsByClassName('rz-modal-close')[0];
  span.onclick = function (e) {
    e.stopPropagation();
    modal.style.display = 'none';
    onClose('dismiss');
  };
  window.onclick = function (event) {
    if (event.target === modal) {
      modal.style.display = 'none';
      onClose();
    }
  };
};

var closeModal = function closeModal(_ref) {
  var id = _ref.id;

  var modal = document.getElementById(id);
  modal.style.display = 'none';
  onClose();
};

module.exports = {
  initModal: function initModal(opts) {
    setTimeout(function () {
      return _initModal(opts);
    }, 1);
  },

  closeModal: closeModal
};

},{}],15:[function(require,module,exports){
'use strict';

var metadataFields = ['jobCatCodes', 'subjects', 'workplaces', 'positions', 'years', 'tags', 'section', 'id', 'title', 'type', 'page_id', 'branch_id', 'phase', 'country', 'subscription', 'other'];

var Metadata = function Metadata(rzWindow) {
  var tesPageMetadata = rzWindow.TES && rzWindow.TES.pageMetadata;

  var parameters = metadataFields.reduce(function (acc, field) {
    if (tesPageMetadata && tesPageMetadata[field]) {
      acc[field] = tesPageMetadata[field];
    }
    return acc;
  }, {});

  var emit_mz_impression_event = function emit_mz_impression_event(metadata) {
    var mergedPageMetadata = metadata.reduce(function (acc, current) {
      if (current) {
        Object.keys(current).map(function (key) {
          return acc[key] = current[key];
        });
      }
      return acc;
    }, tesPageMetadata);

    rzWindow.TES.pageMetadata = mergedPageMetadata;
    rzWindow._mz.pageMetadata = mergedPageMetadata;
    rzWindow._mz.emit(rzWindow._mze.IMPRESSION);
  };

  return {
    parameters: parameters,
    emit_mz_impression_event: emit_mz_impression_event
  };
};

module.exports = Metadata;

},{}],16:[function(require,module,exports){
'use strict';

var asArray = function asArray(value) {
  return Array.isArray(value) ? value : [value];
};

var parseParametersToQueryString = function parseParametersToQueryString(parameters) {
  return Object.keys(parameters).reduce(function (acc, field) {
    var fieldValues = asArray(parameters[field]);
    return acc.concat(fieldValues.map(function (value) {
      return field + '=' + encodeURIComponent(value);
    }).join('&'));
  }, []).join('&');
};

module.exports = parseParametersToQueryString;

},{}],17:[function(require,module,exports){
'use strict';

var superagent = require('superagent');
var superagentPromisePlugin = require('superagent-promise-plugin');

superagentPromisePlugin.Promise = require('es6-promise');

var get = function get(endpoint) {
  return superagent.get(endpoint).use(superagentPromisePlugin).withCredentials().timeout(4000).set({
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  });
};

var post = function post(endpoint, data) {
  return superagent.post(endpoint).use(superagentPromisePlugin).withCredentials().timeout(2000).set({
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }).send(data);
};

module.exports = { get: get, post: post };

},{"es6-promise":3,"superagent":8,"superagent-promise-plugin":5}],18:[function(require,module,exports){
'use strict';

var Rz = require('./rz');

var w = window ? window : {};
var d = document ? document : {};

w.TES = w.TES || {};
w.TES.rz = w.TES.rz || new Rz(w, d);
w._rz = w.TES.rz;

},{"./rz":19}],19:[function(require,module,exports){
'use strict';

var _es6Promise = require('es6-promise');

var _sections = require('./sections');

var _sections2 = _interopRequireDefault(_sections);

var _metadata2 = require('./lib/metadata');

var _metadata3 = _interopRequireDefault(_metadata2);

var _parameters = require('./lib/parameters');

var _parameters2 = _interopRequireDefault(_parameters);

var _request = require('./lib/request');

var _styles = require('../dist/styles.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function siteCountry(rzWindow) {
  var siteCountryMatch = rzWindow.location.pathname.match(/^\/[a-z]{2}-([a-z]{2})\//);
  return siteCountryMatch && siteCountryMatch[1].toUpperCase() || 'GB';
}

function getSectionParameters(rzWindow, section) {
  var _ref = new _metadata3.default(rzWindow),
      pageMetadata = _ref.parameters;

  var sectionParameters = section.parameters ? section.parameters(rzWindow) : {};
  return Object.assign(pageMetadata, sectionParameters, { siteCountry: siteCountry(rzWindow) });
}

function getSectionDataUrl(_ref2, section) {
  var rzWindow = _ref2.rzWindow,
      rzDocument = _ref2.rzDocument;

  var host = rzWindow.TES && rzWindow.TES.domain || '';
  var sectionParameters = getSectionParameters(rzWindow, section);
  var query = (0, _parameters2.default)(sectionParameters);
  query = query ? '?' + query : '';
  return '' + host + section.endpoint + query;
}

function dispatchRzReadyEvent(_ref3, rz) {
  var rzDocument = _ref3.rzDocument;

  var rzReadyEvent = rzDocument.createEvent('CustomEvent');
  rzReadyEvent.initCustomEvent('rzReady', false, false, rz);
  rzDocument.dispatchEvent(rzReadyEvent);
}

var _renderStylesOnce = function renderStylesOnce(_ref4) {
  var rzDocument = _ref4.rzDocument;

  var style = rzDocument.createElement('style');
  style.setAttribute('type', 'text/css');
  style.innerHTML = _styles.styles;
  rzDocument.body.appendChild(style);
  _renderStylesOnce = function renderStylesOnce() {/* noop */};
};

var hideElement = function hideElement(node) {
  if (node) {
    node.style.display = 'none';
  }
};
var showElement = function showElement(node) {
  if (node) {
    node.style.display = '';
  }
};

var Rz = function Rz(rzWindow, rzDocument) {
  _classCallCheck(this, Rz);

  var _ref5 = new _metadata3.default(rzWindow),
      emit_mz_impression_event = _ref5.emit_mz_impression_event;

  var dynamicSections = [];

  var loadSection = function loadSection(_ref6, doRegisterListeners) {
    var sectionName = _ref6.sectionName,
        node = _ref6.node;

    var section = _sections2.default[sectionName];
    if (!section) {
      hideElement(node);
      return {};
    }
    if (doRegisterListeners && section.registerListenersOnNode) {
      section.registerListenersOnNode(rzWindow, rzDocument, node);
    }

    var start = _es6Promise.Promise.resolve({ body: { results: [1] } });

    if (section.endpoint) {
      var url = getSectionDataUrl({ rzWindow: rzWindow, rzDocument: rzDocument }, section);
      start = (0, _request.get)(url);
    }

    return start.then(function (response) {
      var results = response.body.results;

      if (!results || results.length === 0) {
        hideElement(node);
        return {};
      }
      _renderStylesOnce({ rzDocument: rzDocument });
      if (node && section.render) {
        showElement(node);

        var _section$render = section.render(response.body, rzWindow, rzDocument, node),
            html = _section$render.html,
            metadata = _section$render.metadata;

        node.innerHTML = html;
        if (doRegisterListeners && section.registerListeners) {
          section.registerListeners(rzWindow, rzDocument, node);
        }
        return metadata;
      }
      if (section.receiveData) {
        var _section$receiveData = section.receiveData(results, rzWindow, rzDocument),
            _metadata = _section$receiveData.metadata;

        return _metadata;
      }
      return {};
    }).catch(function () {
      hideElement(node);
      return {};
    });
  };

  var getNodesBySectionName = function getNodesBySectionName(sectionNames) {
    return sectionNames.map(function (sectionName) {
      return { sectionName: sectionName, node: rzDocument.querySelector('[data-rz=' + sectionName + ']') };
    });
  };

  function loadSections(firstRun, sectionNames) {

    var sectionsToReload = void 0;
    if (sectionNames) {
      sectionsToReload = getNodesBySectionName(sectionNames);
    } else {
      var zoneSelector = firstRun ? '[data-rz]' : '[data-rz][data-rz-auto-reload]';
      var rz_nodes = [].slice.call(rzDocument.querySelectorAll(zoneSelector));
      var sectionsWithNodes = rz_nodes.map(function (node) {
        return { node: node, sectionName: node.getAttribute('data-rz') };
      });
      var sectionNamesWithNodes = sectionsWithNodes.map(function (_ref7) {
        var sectionName = _ref7.sectionName;
        return sectionName;
      });
      var sectionsWithoutNodes = dynamicSections.filter(function (s) {
        return sectionNamesWithNodes.indexOf(s) === -1;
      }).map(function (sectionName) {
        return { sectionName: sectionName };
      });
      sectionsToReload = sectionsWithNodes.concat(sectionsWithoutNodes);
    }

    return _es6Promise.Promise.all(sectionsToReload.map(function (s) {
      return loadSection(s, firstRun);
    })).then(function (values) {
      var valuesWithKeys = values.filter(function (v) {
        return Object.keys(v).length > 0;
      });
      if (valuesWithKeys.length > 0) {
        emit_mz_impression_event(values);
      }
      return null;
    });
  }

  var startUpPromise = loadSections(true);

  rzDocument.addEventListener('fireRz', function () {
    loadSections(false);
  }, false);

  Object.assign(this, {
    then: function then(fn) {
      return startUpPromise.then(fn);
    },
    catch: function _catch(fn) {
      return startUpPromise.catch(fn);
    },
    registerDynamicSection: function registerDynamicSection(sectionName) {
      dynamicSections.push(sectionName);
      loadSections(true, [sectionName]);
    },

    loadSections: loadSections,
    loadSection: loadSection
  });
  dispatchRzReadyEvent({ rzDocument: rzDocument }, this);
};

module.exports = Rz;

},{"../dist/styles.js":1,"./lib/metadata":15,"./lib/parameters":16,"./lib/request":17,"./sections":28,"es6-promise":3}],20:[function(require,module,exports){
(function (global){
'use strict';

var compare = function compare(a, b) {
  var contentA = a.rawContent || a.content;
  var contentB = b.rawContent || b.content;

  if (contentA.priority < contentB.priority) {
    return -1;
  }
  if (contentA.priority > contentB.priority) {
    return 1;
  }
  return 0;
};

var actionObjectToFunction = function actionObjectToFunction(choosenBanner) {
  if (!choosenBanner.actions) {
    return {};
  }
  var newActionObj = {};
  var actionsKeys = Object.keys(choosenBanner.actions);
  actionsKeys.forEach(function (actionName) {
    var actionType = choosenBanner.actions[actionName];
    var mzData = actionType.mz;
    var emitMz = actionType.emitMz;
    if (mzData) {
      emitMz = actionType.emitMz = emitMz ? Array.isArray(emitMz) ? emitMz : [emitMz] : [];
      emitMz.push({ event: 'CLICK', type: 'upsert-profile-metadata', data: mzData });
    }

    newActionObj[actionName] = function () {
      if (emitMz) {
        var mzItems = Array.isArray(emitMz) ? emitMz : [emitMz];
        mzItems.forEach(function (mzItem) {
          var payload = Object.assign({}, mzItem);
          var event = payload.event;
          delete payload.event;
          global._mz.emit(global._mze[event], payload);
        });
      }
    };
  });
  return newActionObj;
};

var hasChildren = function hasChildren(parent) {
  return !!(parent.children && parent.children.length);
};

var getBanner = function getBanner(results) {
  var defaultBanner = results[0];
  var customBanners = hasChildren(defaultBanner) ? defaultBanner.children : [defaultBanner];
  var singleItem = customBanners.sort(compare)[0];
  if (!hasChildren(singleItem)) {
    return singleItem;
  }
  var item = Math.floor(Math.random() * (singleItem.children.length - 1));
  return singleItem.children[item];
};

var actions = [];

var banners = {
  endpoint: '/api/rz/banners',
  parameters: function parameters(rzWindow) {
    var pathNameArray = rzWindow.location.pathname.split('/');
    return {
      resourceId: pathNameArray[pathNameArray.length - 2],
      rootUrl: rzWindow.location && rzWindow.location.origin
    };
  },
  registerListeners: function registerListeners(rzWindow, rzDocument, node) {
    node.addEventListener('click', function (evt) {
      var rzAction = evt.target.getAttribute('data-rz-action');
      if (rzAction) {
        actions[rzAction]();
        setTimeout(function () {
          var fireRzEvent = rzDocument.createEvent('Event');
          fireRzEvent.initEvent('fireRz', false, false);
          rzDocument.dispatchEvent(fireRzEvent);
        }, 500);
      }
    });
  },
  render: function render(response) {

    var banner = getBanner(response.results);
    actions = actionObjectToFunction(banner);
    if (actions.view) {
      actions.view();
    }

    return {
      html: banner.content,
      metadata: {}
    };
  }
};

module.exports = banners;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],21:[function(require,module,exports){
'use strict';

var community = {
  endpoint: '/api/rz/community',
  render: function render(response) {
    var recommendedCommunityUrls = [];
    var item = response.results[0];
    var output = '';

    if (item) {
      recommendedCommunityUrls.push(item.url);
      output = '\n        <div class="rz"><a class="link--unstyled" href="' + item.url + '" data-mz="true" data-module="community-contextual">\n          <div class="rz-community__card">\n            <div class="rz__label rz__label--community">community forum</div>\n            <div class="rz-community__text-container"></div>\n            <div class="rz-community__text-title">' + item.title + '</div>\n            <div class="rz-communit__text-description">' + item.description + '</div>\n          </div>\n         </a>\n        </div>';
    }

    var html = '<div class="rz">' + output + '</div>';
    return {
      html: html,
      metadata: {
        recommendedCommunityUrls: recommendedCommunityUrls
      }
    };
  }
};

module.exports = community;

},{}],22:[function(require,module,exports){
'use strict';

var ctaTypes = { PRIMARY: 'primary', SECONDARY: 'secondary' };

var CTA = function CTA(_CTA, CTAtype) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};


  if (!_CTA || !_CTA.title) {
    return '';
  }

  var image = _CTA.image,
      link_text = _CTA.link_text,
      link_url = _CTA.link_url,
      text = _CTA.text,
      title = _CTA.title,
      imgPlaceholder = _CTA.imgPlaceholder;
  var isSurvey = options.isSurvey;


  var theme = _CTA.theme || options.theme || 'cerulian';
  var type = CTAtype || ctaTypes.PRIMARY;
  var buttonTheme = type === ctaTypes.SECONDARY ? 'currentColor' : 'primary-dark';
  return '\n    <div class="cms-content">\n      <div class="cms-cta cms-cta--type-' + type + ' cms-cta--theme-' + theme + (isSurvey ? ' cms-cta--survey' : '') + '">\n        ' + (image ? '<div class="cms-cta__img-wrapper">\n          <img width="300" height="168" class="cms-cta__img" alt=' + imgPlaceholder + ' src=' + image + ' />\n          ' + (imgPlaceholder ? '<div class="cms-cta__img-placeholder">' + imgPlaceholder + '</div>' : '') + '\n        </div>' : '') + '\n        \n        <div class="cms-cta__content">\n          ' + (isSurvey ? '<div class="cms-cta__survey-column"></div>' : '') + '\n          <div class="cms-cta__text">' + title + '</div>\n          ' + (text ? '<div class="cms-cta__subtext">' + text + '</div>' : '') + '\n          ' + (link_url ? '<div class="cms-cta__button-wrapper">\n            <a data-mz target="_blank" href=' + link_url + ' class="tds-btn tds-btn--' + buttonTheme + '">' + link_text + '</a>\n          </div>' : '') + '\n        </div>\n      </div>\n    </div>\n  ';
};

var renderPrimary = function renderPrimary(primary) {
  return primary ? CTA(primary) : '';
};
var renderSecondary = function renderSecondary(secondary) {
  return secondary ? CTA(secondary, ctaTypes.SECONDARY) : '';
};
var renderImage = function renderImage(image) {
  return image ? CTA(image, ctaTypes.SECONDARY, { theme: 'pacific-blue' }) : '';
};
var renderSurvey = function renderSurvey(survey) {
  return survey ? CTA(survey, ctaTypes.PRIMARY, { isSurvey: true }) : '';
};

module.exports = {
  renderPrimary: renderPrimary,
  renderSecondary: renderSecondary,
  renderImage: renderImage,
  renderSurvey: renderSurvey
};

},{}],23:[function(require,module,exports){
'use strict';

var _renderIntro = require('./renderIntro');

var _renderIntro2 = _interopRequireDefault(_renderIntro);

var _renderFaqs = require('./renderFaqs');

var _renderFaqs2 = _interopRequireDefault(_renderFaqs);

var _renderSupply = require('./renderSupply');

var _renderSupply2 = _interopRequireDefault(_renderSupply);

var _callsToAction = require('./callsToAction');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var drupal = {
  endpoint: '/api/rz/drupal',
  render: function render(_ref) {
    var results = _ref.results;
    var intro = results.intro,
        faqs = results.faqs,
        supply = results.supply,
        primary = results.primary,
        secondary = results.secondary,
        image = results.image,
        survey = results.survey;


    var output = !results ? '' : '\n      ' + (0, _renderIntro2.default)(intro) + '\n      ' + (0, _renderFaqs2.default)(faqs) + '\n      ' + (0, _renderSupply2.default)(supply) + '\n      ' + (0, _callsToAction.renderPrimary)(primary) + '\n      ' + (0, _callsToAction.renderSecondary)(secondary) + '\n      ' + (0, _callsToAction.renderImage)(image) + '\n      ' + (0, _callsToAction.renderSurvey)(survey);

    var html = '<div class="rz">' + output + '</div>';
    return {
      html: html,
      metadata: {}
    };
  }
};

module.exports = drupal;

},{"./callsToAction":22,"./renderFaqs":25,"./renderIntro":26,"./renderSupply":27}],24:[function(require,module,exports){
'use strict';

module.exports = function (id, childContent, closed) {
  return '\n    <div class="cms-content">\n      <input class="collapsible__toggle" id=' + id + ' type="checkbox" ' + (closed ? 'checked' : '') + ' />\n      <div class="collapsible">\n        <label class="collapsible__button" for=' + id + '>\n            <i class="icon icon--unit-sm collapsible__icon">Collapse</i>\n        </label>\n        <div class="collapsible__content">\n        ' + childContent + '\n        </div>\n      </div>\n    </div>\n  ';
};

},{}],25:[function(require,module,exports){
'use strict';

var _renderCollapsible = require('./renderCollapsible');

var _renderCollapsible2 = _interopRequireDefault(_renderCollapsible);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = function (faqs) {
  if (!faqs || !faqs.length) {
    return '';
  }

  var questionsContent = faqs.map(function (_ref) {
    var title = _ref.title,
        text = _ref.text;
    return '<div class="cms-faq__group">\n         <div class="cms-faq__q">' + title + '</div>\n         <div class="cms-faq__a" >' + text + '</div>\n          </div>';
  });

  var faqsContent = '\n    <div class="cms-faq">\n      <div class="cms-faq__title">\n        <label for="cms-faqs"><i class="icon icon--unit-md cms-faq__icon">Faq</i><span>FAQs</span></label>\n      </div>\n      <div class="cms-faq__content">\n      ' + questionsContent.join('') + '\n      </div>\n    </div>\n        ';

  return (0, _renderCollapsible2.default)('cms-faqs', faqsContent, true);
};

},{"./renderCollapsible":24}],26:[function(require,module,exports){
'use strict';

var _renderCollapsible = require('./renderCollapsible');

var _renderCollapsible2 = _interopRequireDefault(_renderCollapsible);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = function (intro) {
  if (!(intro && intro.text && intro.title)) {
    return '';
  }

  var title = intro.title,
      text = intro.text;


  var introContent = '\n    <div class="cms-intro">\n      <div class="cms-intro__title">\n        <label for="cms-intro"><i class="icon icon--unit-md cms-intro__icon">Info</i><span>' + title + '</span></label>\n      </div>\n      <div class="cms-intro__content">' + text + '</div>\n    </div>\n  ';

  return (0, _renderCollapsible2.default)('cms-intro', introContent);
};

},{"./renderCollapsible":24}],27:[function(require,module,exports){
'use strict';

module.exports = function (supply) {
  if (!supply) {
    return '';
  }

  var image = supply.image,
      title = supply.title,
      text = supply.text,
      phone = supply.phone,
      link_url = supply.link_url,
      link_text = supply.link_text;
  // Formatting within the cms-supply-cta__contact block should be preserved to avoid whitespace and layout issues

  return '\n    <div class="cms-content">\n      <div class="cms-supply-cta">\n        <div>\n          ' + (image ? '<div class="cms-supply-cta__img" style="background-image: url(' + image + ')">\n            ' + title + '\n          </div>' : '') + '\n    \n          <div class="cms-supply-cta__content">\n            <div class="cms-supply-cta__title">' + title + '</div>\n            <div class="cms-supply-cta__text">' + text + '</div>\n            <div class="cms-supply-cta__contact">\n                <span class="cms-supply-cta__link">\n                  <a data-mz target="_blank" href=' + link_url + ' class="tds-btn tds-btn--secondary">' + link_text + '</a>\n                </span>' + (phone ? '<div class="cms-supply-cta__phone">\n                  <i class="icon cms-supply-cta__phone-icon icon--unit-md"></i><span \n                  class="cms-supply-cta__phone-number">Supply bookings<br />' + phone + '</span>\n                </div>' : '') + '\n            </div> \n          </div>\n        </div>\n      </div>\n    </div>\n';
};

},{}],28:[function(require,module,exports){
'use strict';

var _talentCapture = require('./talentCapture');

var _talentCapture2 = _interopRequireDefault(_talentCapture);

var _community = require('./community');

var _community2 = _interopRequireDefault(_community);

var _institute = require('./institute');

var _institute2 = _interopRequireDefault(_institute);

var _targeted = require('./targeted');

var _targeted2 = _interopRequireDefault(_targeted);

var _rebrandJobs = require('./rebrandJobs');

var _rebrandJobs2 = _interopRequireDefault(_rebrandJobs);

var _news = require('./news');

var _news2 = _interopRequireDefault(_news);

var _resources = require('./resources');

var _resources2 = _interopRequireDefault(_resources);

var _resourcesSlider = require('./resourcesSlider');

var _resourcesSlider2 = _interopRequireDefault(_resourcesSlider);

var _qa = require('./qa');

var _qa2 = _interopRequireDefault(_qa);

var _tooltip = require('./tooltip');

var _tooltip2 = _interopRequireDefault(_tooltip);

var _banners = require('./banners');

var _banners2 = _interopRequireDefault(_banners);

var _modal = require('./modal');

var _modal2 = _interopRequireDefault(_modal);

var _drupal = require('./drupal');

var _drupal2 = _interopRequireDefault(_drupal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sections = {
  talentCapture: _talentCapture2.default,
  community: _community2.default,
  institute: _institute2.default,
  targeted: _targeted2.default,
  rebrandJobs: _rebrandJobs2.default,
  news: _news2.default,
  resources: _resources2.default,
  resourcesSlider: _resourcesSlider2.default,
  qa: _qa2.default,
  tooltip: _tooltip2.default,
  banners: _banners2.default,
  modal: _modal2.default,
  drupal: _drupal2.default
};

module.exports = sections;

},{"./banners":20,"./community":21,"./drupal":23,"./institute":29,"./modal":30,"./news":31,"./qa":32,"./rebrandJobs":33,"./resources":34,"./resourcesSlider":35,"./talentCapture":36,"./targeted":37,"./tooltip":38}],29:[function(require,module,exports){
'use strict';

var _helpers = require('../lib/helpers');

var institute = {
  endpoint: '/api/rz/institute',
  render: function render(response) {
    var course = response.results;
    var courseOutput = '';
    var recommendedInstituteUrls = [];

    if (course) {
      recommendedInstituteUrls.push(course.url);

      var bannerDiv = course.image_200x164.src ? '<div class="rz-card__image-container rz-card__image-container--small responsive-image">\n           <img class="responsive-image__inner responsive-image__inner--height-auto" src="' + course.image_200x164.src + '" srcset="' + course.image_200x164.src + ' 2x"/>\n         </div>' : '';
      course.shortDescription = (0, _helpers.shorten)(course.description, 111);

      courseOutput = '\n        <div class="rz-card">\n          ' + bannerDiv + '\n          <div class="rz-card__body rz-card__body--no-border">\n            <div class="rz__label rz__label--institute">\n              featured course\n            </div>\n            <div class="padding-top-bottom-sm">\n              <h4 class="rz-card__headline rz-card__headline--lg">' + course.title + '</h4>\n              <p class="rz-card__description">' + course.shortDescription + '&nbsp;\n                <a class="link link--colored" data-mz="true" data-module="institute-contextual" href="' + course.url + '">More</a>\n              </p>\n            </div>\n            <div class="rz__feature-button-container border-top">\n              <span class="rz-institute__course-duration">\n                 <i class="icon icon-clock-o icon-gray"></i>\n                 <span class="text text--discreet">' + course.course_length + '</span>\n              </span>\n              <a href="' + course.url + '" data-mz="true" data-module="institute-contextual" class="tes-btn tes-btn--sm tes-btn--secondary pull-right">View Course</a>\n            </div>\n          </div>\n        </div>\n        ';
    }

    var html = '<div>' + courseOutput + '</div>';

    return {
      html: html,
      metadata: {
        recommendedInstituteUrls: recommendedInstituteUrls
      }
    };
  }
};

module.exports = institute;

},{"../lib/helpers":13}],30:[function(require,module,exports){
(function (global){
'use strict';

var _require = require('../lib/initModal'),
    initModal = _require.initModal,
    closeModal = _require.closeModal;

var actions = void 0;
var _mz = global._mz;
var _mze = global._mze;

var invokeAction = function invokeAction(action) {
  var actionType = action;
  var emitMz = actionType.emitMz;
  emitMz = actionType.emitMz = emitMz ? Array.isArray(emitMz) ? emitMz : [emitMz] : [];

  if (actionType.mz) {
    emitMz.push({ event: 'CLICK', type: 'upsert-profile-metadata', data: actionType.mz });
    delete actionType.mz;
  }
  emitMz.forEach(function (mzItem) {
    var payload = Object.assign({}, mzItem);
    var event = payload.event;
    delete payload.event;
    _mz.emit(_mze[event], payload);
  });
};

var modal = {
  endpoint: '/api/rz/modals',
  registerListenersOnNode: function registerListenersOnNode(rzWindow, rzDocument, node) {
    node.addEventListener('click', function (evt) {
      var rzAction = evt.target.getAttribute('data-rz-action');
      if (rzAction) {
        invokeAction(actions[rzAction]);
      }
      closeModal({ id: 'rz-modal' });
    });
  },
  render: function render(response, rzWindow, rzDocument) {
    var item = response.results[0];

    var output = '';

    var modalOuterClass = item.rawContent && item.rawContent.customStyle && item.rawContent.customStyle.rzModalOuterClass ? item.rawContent.customStyle.rzModalOuterClass : 'rz-modal-content';

    var modalInnerClass = item.rawContent && item.rawContent.customStyle && item.rawContent.customStyle.rzModalInnerClass ? item.rawContent.customStyle.rzModalInnerClass : 'rz-modal-inner-content';

    if (item) {
      actions = item.actions;
      if (item.actions.view) {
        invokeAction(item.actions.view);
      }
      output = '\n        <div class="rz">\n          <div id="rz-modal" class="rz-modal">\n            <div class="' + modalOuterClass + '">\n              <span class="rz-modal-close">&times;</span>\n              <div class="' + modalInnerClass + '">\n                ' + item.content + '\n              </div>\n            </div>\n          </div>\n        </div>';
      initModal({
        id: 'rz-modal',
        onClose: function onClose(reason) {
          if (reason === 'dismiss' && actions.dismiss) {
            invokeAction(actions.dismiss);
          }
          setTimeout(function () {
            var fireRzEvent = rzDocument.createEvent('Event');
            fireRzEvent.initEvent('fireRz', false, false);
            rzDocument.dispatchEvent(fireRzEvent);
          }, 500);
        }
      });
    }
    var html = '<div class="rz">' + output + '</div>';

    return {
      html: html,
      metadata: {}
    };
  }
};

module.exports = modal;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"../lib/initModal":14}],31:[function(require,module,exports){
'use strict';

var _helpers = require('../lib/helpers');

var news = {
  endpoint: '/api/rz/news',
  render: function render(response) {
    var limit = 5;
    var items = [];
    var recommendedNewsUrls = [];

    for (var position = 1; position <= limit; position++) {
      var item = response.results[position - 1];

      if (item) {
        var logoDiv = item.image2 ? '<img class="responsive-image__inner responsive-image__inner--height-auto" src="' + item.image2 + '"/>' : '';

        item.shortTitle = (0, _helpers.shorten)(item.title, 70);
        item.shortDescription = (0, _helpers.shorten)(item.description, 90 - item.shortTitle.length);

        recommendedNewsUrls.push(item.path);

        items.push('\n        <li data-position="' + position + '">\n          <a class="link--unstyled rz-list__item" data-mz="true" data-module="news-contextual" href="' + item.path + '">\n            <div class="rz__text-container">\n              <h4 class="rz-list__item-title l-inline">' + item.shortTitle + '.</h4>\n              <p class="rz-list__item-text l-inline">' + item.shortDescription + '</p>\n            </div>\n            <div class="rz-image-container">\n              ' + logoDiv + '\n            </div>\n          </a>\n        </li>\n        ');
      }
    }

    var html = '\n      <div class="rz">\n        <h3 class="rz__title rz__title--pink">Recommended News</h3>\n        <ul class="rz-list list-unstyled">\n          ' + items.join('') + '\n        </ul>\n      </div>\n      ';
    return {
      html: html,
      metadata: {
        recommendedNewsUrls: recommendedNewsUrls
      }
    };
  }
};

module.exports = news;

},{"../lib/helpers":13}],32:[function(require,module,exports){
'use strict';

var qa = {
  endpoint: '/api/rz/qa',
  render: function render(response) {
    var results = response.results;
    var questions = results.questions;
    var recommendedQaUrls = [];
    var output = '';

    var secondItem = questions[1] ? '<li>\n                <a class="link--unstyled" href="' + questions[1].url + '" data-mz="true" data-module="community-contextual">\n                  <div class="rz-community__text-title">' + questions[1].title + '</div>\n                  <div class="rz-communit__text-description">' + questions[1].content + '</div>\n                </a> \n              </li>' : '';

    if (questions[0]) {
      recommendedQaUrls.push(questions[0].url);
      if (questions[1]) {
        recommendedQaUrls.push(questions[1].url);
      }
      output = '\n        <div class="rz">\n          <div class="rz-community__card">\n            <div class="rz__label rz__label--community">q&a</div>\n            <div class="rz-community__text-container"></div>\n            <ul>\n              <li>\n                <a class="link--unstyled" href="' + questions[0].url + '" data-mz="true" data-module="community-contextual">\n                  <div class="rz-community__text-title">' + questions[0].title + '</div>\n                  <div class="rz-communit__text-description">' + questions[0].content + '</div>\n                </a>\n              </li>\n              ' + secondItem + '\n            </ul>\n            <div>\n              <a class="link link--colored" data-mz="true" data-module="community-contextual" href="' + results.tagUrl + '">More</a>\n            </div>\n          </div>\n        </div>';
    }

    var html = '<div class="rz">' + output + '</div>';
    return {
      html: html,
      metadata: {
        recommendedQaUrls: recommendedQaUrls
      }
    };
  }
};

module.exports = qa;

},{}],33:[function(require,module,exports){
'use strict';

var _helpers = require('../lib/helpers');

var jobs = {
  endpoint: '/api/rz/jobs',
  render: function render(response) {
    var results = response.results;
    var spotlightExclusiveJobIds = [];
    var spotlightJobIds = [];

    var items = [];
    var featureItem = '';
    for (var position = 1; position <= results.length; position++) {
      var item = results[position - 1];
      if (item) {
        var subheading = item.organisation && item.location ? item.organisation + ', ' + item.location : item.organisation || item.location || '';
        var logoDiv = item.logo ? '<img class="responsive-image__inner responsive-image__inner--height-auto" src="' + item.logo + '"/>' : '';
        if (item.type === 'exclusive') {
          spotlightExclusiveJobIds.push(item.jobId);
          item.shortDescription = (0, _helpers.shorten)(item.description, 75);

          var applyBy = item.applyBy ? 'Closing date ' + item.applyBy : '';
          var bannerDiv = item.banner ? '<div class="rz-job__img-container responsive-image"><img class="responsive-image__inner" src="' + item.banner + '" srcset="' + item.banner2x + ' 2x"/></div>' : '';
          featureItem = '\n          <div class="rz-job">\n              ' + bannerDiv + '\n           <a class="link--unstyled" data-mz="true" data-module="job-exclusive" data-id="' + item.promoId + '" href="' + item.url + '">\n            <div class="rz-job__body">\n              <div class="rz-job__feature">\n                <div class="rz__text-container">\n                  ' + (!!item.quickApply ? '<div class="rz-quick-apply-label">quick apply</div>' : '') + '\n                  <h2 class="rz-job__feature-title">' + item.title + '</h2>\n                  <p class="rz-job__feature-location text--discreet">' + item.location + '</p>\n                </div>\n                <div class="rz-image-container">\n                  ' + logoDiv + '\n                </div>\n              </div>\n              <div class="rz-job__feature-description">' + item.shortDescription + '</div>\n              <div class="rz__feature-button-container">\n                <span class="rz-job__feature-expiry">' + applyBy + '</span>\n                <button class="tes-btn tes-btn--sm tes-btn--secondary pull-right">View job</button>\n              </div>\n             </div>\n            </a>\n          </div>\n\n      ';
        } else {
          spotlightJobIds.push(item.jobId);
          items.push('\n          <li data-position="' + position + '">\n            <a\n              class="link--unstyled rz-list__item"\n              data-mz="true"\n              data-module="job-' + item.type + '"\n              data-id="' + item.promoId + '"\n              href="' + item.url + '"\n            >\n              <div class="rz__text-container">\n                ' + (!!item.quickApply ? '<div class="rz-quick-apply-label">quick apply</div>' : '') + '\n                <h4 class="rz-list__item-title l-inline">' + item.title + '</h4>\n                <p class="rz-list__item-text l-inline">' + subheading + '</p>\n              </div>\n              <div class="rz-image-container">\n                ' + logoDiv + '\n              </div>\n            </a>\n          </li>\n          ');
        }
      }
    }
    var html = '\n      <div class="rz">\n        <h3 class="rz__title rz__title--mint">' + (response.title || 'Jobs recommended for you') + '</h3>\n          ' + featureItem + '\n        <ul class="rz-list list-unstyled">\n          ' + items.join('') + '\n        </ul>\n      </div>\n      ';
    return {
      html: html,
      metadata: {
        spotlightExclusiveJobIds: spotlightExclusiveJobIds,
        spotlightJobIds: spotlightJobIds
      }
    };
  }
};

module.exports = jobs;

},{"../lib/helpers":13}],34:[function(require,module,exports){
'use strict';

var _helpers = require('../lib/helpers');

var _request = require('../lib/request');

var saveStates = {
  SAVE: 'resource-card__media-footer__icon icon icon-bookmark-v2 icon-light-gray',
  SAVED: 'resource-card__media-footer__icon icon icon-bookmark-v2 icon-blue',
  SAVING: 'resource-card__media-footer__icon icon icon-bookmark-v2 icon-gray'
};

var saveHandler = function saveHandler(el, rzWindow) {
  return function () {
    var isLoggedIn = !!rzWindow.Cookies.get('TESCookieUser');
    var resourceId = el.getAttribute('data-rz-resource');
    var saveIcon = el.getElementsByTagName('i')[0];

    var save = function save() {
      if (saveIcon.className !== saveStates.SAVE) {
        return;
      }
      saveIcon.setAttribute('class', saveStates.SAVING);
      (0, _request.post)('/api/favourites/v1', { applicationId: resourceId }).then(function (response) {
        if (response.status === 200 && response.body && response.body.isFavourite) {
          saveIcon.setAttribute('class', saveStates.SAVED);
          rzWindow._mz.emit(rzWindow._mze.CLICK, {
            eventTitle: 'save',
            id: resourceId,
            module: {
              type: 'resource-contextual',
              name: 'rz'
            }
          });
        } else {
          saveIcon.setAttribute('class', saveStates.SAVE);
        }
      }).catch(function () {
        saveIcon.setAttribute('class', saveStates.SAVE);
      });
    };

    if (isLoggedIn) {
      save();
    } else {
      var events = rzWindow.TES && rzWindow.TES.events;
      events.trigger('auth-open', 'sign-in', false);
      events.on('logged-in', function () {
        save();
      });
    }
  };
};

var resources = {
  endpoint: '/api/rz/resources',
  registerListeners: function registerListeners(rzWindow, rzDocument) {
    var saveElements = rzDocument.querySelectorAll('[data-rz-event-emitter]');
    for (var i = 0; i < saveElements.length; i++) {
      var element = saveElements[i];
      element.onclick = saveHandler(element, rzWindow);
    }
  },
  render: function render(response) {
    var getStars = function getStars(rating) {
      var stars = [];

      for (var star = 0; star < 5; star++) {
        var remaining = rating - star;
        if (remaining >= 1) {
          stars.push('<i class="rating__icon rating__icon--sm icon icon-star icon-yellow"></i>');
        } else if (remaining > 0) {
          stars.push('<i class="rating__icon rating__icon--sm icon icon-star-half-o icon-yellow"></i>');
        } else {
          stars.push('<i class="rating__icon rating__icon--sm icon icon-star-o icon-yellow"></i>');
        }
      }
      return stars;
    };

    var limit = 4;
    var items = [];
    var recommendedResourceIds = [];

    for (var position = 1; position <= limit; position++) {
      var item = response.results[position - 1];

      if (item) {
        recommendedResourceIds.push(item.resourceId);
        item.shortDescription = (0, _helpers.shorten)(item.description, 75);
        var discountedPrice = item.discountedPrice || '';
        var cardPriceCssClass = discountedPrice ? 'resource-card__old-price' : 'resource-card__price resource-card__price--sm';
        items.push('\n          <li class="padding-bottom-md">\n            <article class="resource-card resource-card--sm">\n              <div class="resource-card__container resource-card__container--sm">\n                <a data-mz data-module="resource-sidebar-recommended" class="resource-card__media-object-container resource-card__media-object-container--sm" href="' + item.url + '">\n                  <img class="resource-card__media-object" src="' + item.logo + '" alt="' + item.title + '">\n                </a>\n                <div class="resource-card__media-body resource-card__media-body--sm">\n                  <div class="resource-card__clip resource-card__clip--sm">\n                    <h4 class="resource-card__media-heading resource-card__media-heading--sm">\n                      <a data-mz data-module="resource-sidebar-recommended" class="resource-card__media-heading-link" href="' + item.url + '">' + item.title + '</a>\n                    </h4>\n                  </div>\n                  <div class="margin-top-xs">\n                    <div class="rating">\n                      ' + getStars(item.ratingAverage).join(' ') + '\n                      <span class="rating__number rating__number--visible">(' + item.ratingCount + ')</span>\n                    </div>\n                  </div>\n                </div>\n                <ul class="resource-card__media-footer resource-card__media-footer--sm">\n                  <li class="resource-card__media-footer__list resource-card__media-footer__list--sm">\n                    <a class="rz-save-for-later" href="javascript: void(0);" data-rz-event-emitter data-rz-resource="' + item.resourceId + '">\n                      <i class="resource-card__media-footer__icon icon icon-bookmark-v2 icon-light-gray"></i>\n                    </a>\n                  </li>\n                  <li class="resource-card__media-footer__list resource-card__media-footer__list--sm resource-card__media-footer__list--aside">\n                    <span class="' + cardPriceCssClass + '">' + item.price + '</span>\n                    <span class="resource-card__price resource-card__price--sm">' + discountedPrice + '</span>\n                  </li>\n                </ul>\n              </div>\n            </article>\n          </li>\n        ');
      }
    }
    var html = '\n      <div class="rz">\n        <h3 class="rz__title">Recommended resources</h3>\n        <ul class="rz-list rz-list--resources list-unstyled">\n          ' + items.join('') + '\n        </ul>\n      </div>\n      ';
    return {
      html: html,
      metadata: {
        recommendedResourceIds: recommendedResourceIds
      }
    };
  }
};

module.exports = resources;

},{"../lib/helpers":13,"../lib/request":17}],35:[function(require,module,exports){
'use strict';

var _helpers = require('../lib/helpers');

var getCarouselItems = function getCarouselItems() {
  return document.querySelectorAll('.rz-slider__item');
};

var INTERVAL_MS = 3000;
var SLIDE_FORWARD = true;
var SLIDE_BACKWARDS = false;

var timer = null;

var slide = function slide(direction) {
  var nextItem = void 0;

  var items = getCarouselItems();
  var currentItem = Array.prototype.slice.call(items, 0).findIndex(function (item) {
    return item.className === 'rz-slider__item rz-slider__item--active';
  });
  if (direction === SLIDE_FORWARD) {
    nextItem = currentItem + 1;
    if (nextItem >= items.length) {
      nextItem = 0;
    }
  } else {
    nextItem = currentItem - 1;
    if (nextItem < 0) {
      nextItem = items.length - 1;
    }
  }
  items[currentItem].classList.remove('rz-slider__item--active');
  items[nextItem].classList.add('rz-slider__item--active');
};

var timerFn = function timerFn() {
  return slide(SLIDE_FORWARD);
};

var carouselHandler = function carouselHandler(el) {
  return function () {
    clearInterval(timer);
    slide(el.className === 'rz-slider__arrow--backwards' ? SLIDE_BACKWARDS : SLIDE_FORWARD);
    timer = setInterval(timerFn, INTERVAL_MS);
  };
};

var resourcesSlider = {
  endpoint: '/api/rz/resources',
  registerListeners: function registerListeners(rzWindow, rzDocument) {
    var sliderButtons = rzDocument.querySelectorAll('[data-rz-event-emitter]');
    for (var i = 0; i < sliderButtons.length; i++) {
      var element = sliderButtons[i];
      element.onclick = carouselHandler(element, rzWindow);
    }
    timer = setInterval(timerFn, INTERVAL_MS);
  },
  render: function render(response) {
    var getStars = function getStars(rating) {
      var stars = [];

      for (var star = 0; star < 5; star++) {
        var remaining = rating - star;
        if (remaining >= 1) {
          stars.push('<i class="rating__icon rating__icon--sm icon icon-star icon-yellow"></i>');
        } else if (remaining > 0) {
          stars.push('<i class="rating__icon rating__icon--sm icon icon-star-half-o icon-yellow"></i>');
        } else {
          stars.push('<i class="rating__icon rating__icon--sm icon icon-star-o icon-yellow"></i>');
        }
      }
      return stars;
    };

    var limit = 5;
    var items = [];
    var recommendedResourceIds = [];

    for (var position = 1; position <= limit; position++) {
      var item = response.results[position - 1];

      if (item) {
        recommendedResourceIds.push(item.resourceId);
        item.shortDescription = (0, _helpers.shorten)(item.description, 75);
        var discountedPrice = item.discountedPrice || '';
        var cardPriceCssClass = discountedPrice ? 'resource-card__old-price' : 'resource-card__price resource-card__price--sm';
        var activeClass = position === 1 ? 'rz-slider__item--active' : '';
        items.push('\n          <li class="rz-slider__item ' + activeClass + '">\n            <article class="resource-card">\n              <div class="resource-card__container">\n                <div class="resource-card__quick-view-container">\n                  <a\n                    class="resource-card__media-object-container"\n                    href="' + item.url + '"\n                    data-mz\n                    data-module="resource-sidebar-recommended"\n                  >\n                    <img\n                      class="resource-card__media-object"\n                      src="' + item.logo + '"\n                      alt="' + item.title + '"\n                    >\n                  </a>\n                </div>\n                <div class="resource-card__media-body">\n                  <div class="resource-card__clip">\n                    <h4 class="resource-card__media-heading">\n                      <a\n                        class="resource-card__media-heading-link"\n                        href="' + item.url + '"\n                        data-mz\n                        data-module="resource-sidebar-recommended"\n                      >\n                        ' + item.title + '\n                      </a>\n                    </h4>\n                    <div class="resource-card__media-description">' + item.description + '</div>\n                  </div>\n                  <span class="author">\n                    <a\n                      class="author__link"\n                      href="' + item.authorUrl + '"\n                      data-mz\n                    >\n                      ' + item.authorName + '\n                    </a>\n                  </span>\n                </div>\n                <ul class="resource-card__media-footer">\n                  <li class="resource-card__media-footer__list">\n                    <div class="rating">\n                      ' + getStars(item.ratingAverage).join(' ') + '\n                      <span class="rating__number rating__number--visible">(' + item.ratingCount + ')</span>\n                    </div>\n                  </li>\n                  <li class="resource-card__media-footer__list resource-card__media-footer__list--aside">\n                    <span class="' + cardPriceCssClass + '">' + item.price + '</span>\n                    <span class="resource-card__price resource-card__price--sm">' + discountedPrice + '</span>\n                  </li>\n                </ul>\n              </div>\n            </article>\n          </li>\n        ');
      }
    }
    var html = '\n      <div class="rz">\n        <h3 class="rz__title rz__title--pink">Recommended resources</h3>\n        <div class="rz-slider">\n          <i class="rz-slider__arrow rz-slider__arrow--backwards icon icon-tds-chevron-left icon-blue icon--unit-md" data-rz-event-emitter></i>\n          <ul class="rz-list rz-list--resources list-unstyled">\n            ' + items.join('') + '\n          </ul>\n          <i class="rz-slider__arrow rz-slider__arrow--forward icon icon-tds-chevron-right icon-blue icon--unit-md" data-rz-event-emitter></i>\n        </div>\n      </div>\n      ';
    return {
      html: html,
      metadata: {
        recommendedResourceIds: recommendedResourceIds
      }
    };
  }
};

module.exports = resourcesSlider;

},{"../lib/helpers":13}],36:[function(require,module,exports){
'use strict';

var talentCapture = {

  registerListeners: function registerListeners(rzWindow, rzDocument) {
    rzWindow.TES = rzWindow.TES || {};
    var tag = document.createElement('script');
    tag.src = '/cdn/vendor/library/tc-widget-loader.v4.js';
    rzDocument.getElementsByTagName('head')[0].appendChild(tag);
    var widgetContainer = rzDocument.querySelector('div[data-rz="talentCapture"]');

    var widgetConfig = JSON.parse(widgetContainer.getAttribute('data-widget-config'));

    var widget = document.createElement('div');
    widget.id = widgetConfig.id;
    rzDocument.getElementById('rz-tc-widget').appendChild(widget);
    rzWindow.TES.events.stick('load-tc-widget', widgetConfig);
  },

  render: function render() {
    return {
      html: '<div id="rz-tc-widget" class="rz"></div>',
      metadata: {}
    };
  }
};

module.exports = talentCapture;

},{}],37:[function(require,module,exports){
'use strict';

var targeted = {
  endpoint: '/api/rz/targeted',
  render: function render(response) {
    var result = response.results[0];
    var output = '';
    var targetedTags = [];

    if (result) {
      targetedTags.push(result.mz);
      output = '\n        <div class="rz-card">\n          <div class="rz-card__body rz-card__body--no-border">\n            <div class="rz__label rz__label--targeted">' + result.title + '</div>\n            <div class="padding-top-bottom-sm">\n              <h4 class="rz-card__headline rz-card__headline--lg">' + result.header + '</h4>\n              <p class="rz-card__description">' + result.text + '</p>\n            </div>\n            <div class="rz__feature-button-container border-top text-center">\n              <a href="' + result.link + '" data-mz="true" data-module="targeted-contextual" class="tes-btn tes-btn--sm tes-btn--secondary">' + result.button + '</a>\n            </div>\n          </div>\n        </div>\n        ';
    }

    var html = '<div class="rz">' + output + '</div>';

    return {
      html: html,
      metadata: {
        targetedTags: targetedTags
      }
    };
  }
};

module.exports = targeted;

},{}],38:[function(require,module,exports){
(function (global){
'use strict';

var actionObjectToFunction = function actionObjectToFunction(step, index, steps) {
  if (!step.actions) {
    return step;
  }

  var newActionObj = {};
  var actionsKeys = Object.keys(step.actions);
  actionsKeys.forEach(function (actionName) {
    var actionType = step.actions[actionName];
    // todo phase out
    var mzData = actionType.mz;
    // old way of handling mz - phasing out
    var emitMz = actionType.emitMz;
    if (mzData) {
      emitMz = actionType.emitMz = emitMz ? Array.isArray(emitMz) ? emitMz : [emitMz] : [];
      emitMz.push({ event: 'CLICK', type: 'upsert-profile-metadata', data: mzData });
    }
    newActionObj[actionName] = function () {
      if (emitMz) {
        var mzItems = Array.isArray(emitMz) ? emitMz : [emitMz];
        mzItems.forEach(function (mzItem) {
          var payload = Object.assign({}, mzItem);
          var event = payload.event;
          delete payload.event;
          global._mz.emit(global._mze[event], payload);
        });
      }

      if (actionType.navigateTo) {
        document.history.push(actionType.navigateTo);
      }

      if (steps.length === index + 1) {
        var fireRzEvent = document.createEvent('Event');
        fireRzEvent.initEvent('fireRz', false, false);
        setTimeout(function () {
          document.dispatchEvent(fireRzEvent);
        }, 500);
      }
    };
  });

  step.actions = newActionObj;
  return step;
};

var dispatchCustomEvent = function dispatchCustomEvent(rzDocument, steps, context) {
  var joyrideDataEvent = rzDocument.createEvent('CustomEvent');
  joyrideDataEvent.initCustomEvent('joyrideData', false, false, { steps: steps, context: context });
  rzDocument.dispatchEvent(joyrideDataEvent);
};

var transformRzPayloadToSteps = function transformRzPayloadToSteps(child) {
  var step = child.content;
  step.actions = child.actions;
  step.text = step.text || step.description;
  return step;
};

var tooltip = {
  endpoint: '/api/rz/tooltip',
  receiveData: function receiveData(results, rzWindow, rzDocument) {
    if (!results) {
      return {};
    }
    var steps = (results[0].children || []).map(actionObjectToFunction).map(transformRzPayloadToSteps);
    dispatchCustomEvent(rzDocument, steps, results[0]);
    return {
      metadata: {}
    };
  }
};

module.exports = tooltip;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}]},{},[18]);
